import React from 'react';
import Slider from "react-slick";
import { Tooltip } from 'antd';
import './App.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Item from '../global/item';
import ImForm from '../global/Form.png';
import ImForm2 from '../global/Form2.png';
import GCLogo from '../global/GCLogo.png';
import GCLogo2 from '../global/GCLogo2.png';
import Chest_req from '../global/Chest_req.png';
import Chest_rest from '../global/Chest_rest.png';
import List_wb from '../global/List_wb.png';
import List_stove from '../global/List_stove.png';
import List_item from '../global/List_item.png';
import List_group from '../global/List_group.png';
import List_save from '../global/List_save.png';
import List_calc from '../global/List_calc.png';
import List_calc2 from '../global/List_calc2.png';
import Chosen from '../global/Chosen.png';

class App extends React.Component {
	constructor(props) {
    super(props);
    this.state = {
      load: ['','','','','Авторизация не удалась','Непредвиденная ошибка','Проблемы со связью','','','',''],
      crafts:[],                    //Крафты
      clist:[],                     //Список крафтов
      craftsalt:[],                 //Альтернативные крафты
      clistalt:[],                  //Список альтернативных крафтов
      items:[],                     //Список + id
      ilist:[],                     //Список
      listload: false,              //Статус загрузки списка
      cases:[],                     //Сундуки
      icase:null,                   //Выбранный сундук
      chosen:[],                    //Избранные
      chosenac: false,              //Статус избранного
      getCraft: ['',false],         //Поиск крафта
      m1list: {"t":"c", "f":"f", "ri":"0", "rd":0, "i1":"0", "i2":"0", "i3":"0", "i4":"0", "i5":"0", "i6":"0", "i7":"0", "i8":"0", "i9":"0", "d1":0, "d2":0, "d3":0, "d4":0, "d5":0, "d6":0, "d7":0, "d8":0, "d9":0, "s1":0, "s2":0, "s3":0, "s4":0, "s5":0, "s6":0, "s7":0, "s8":0, "s9":0, "s10":0},
      m1active: '',
      historycraft : [],            //История
      part: [],                     //Партнёры
      searchtext: '',               //Поисковой запрос
      loading: true,                //Статус загрузки
      error: 0,                     //Ошибка
      uid: '0',                     //Внутренний UID
      gcid: '',                     //ID GC
      gcname: '',                   //Username GC
      gcrd: '',                     //RegDate GC
      gcprefix: [],                 //Prefix GC
      gcnc: '',                     //Nick color GC
      gcsu: '',                     //Skin GC
      gcbanned: false,              //Banned GC
      lastseen: null,               //Последний вход GC
      online: false,                //Статус GC
      badges: [],                   //Бейджики
      gctoken: '',                  //Token GC
      gcprofile: false,             //Статус панели GC
      gchelp: false,                //Статус панели HELPGC
      widthdoc: '0',                //Ширина документа
      reqstatus: false,             //Статус запроса
      scope: 'user',                //Права
      mode: '0',                    //Режим
      modelist: ['','New','Edit','Del'],                 //Названия режимов
      craftlist: [],                //Список нужных предметов для крафта
      craftrest: [],                //Список лишних предметов при крафте
      countcraft: 1,                //Количество предметов для крафта
      garland:  1,                  //Гирлянда
      users: [],
      users_log: [],
      user: 0,
      nick: '',
      ts: 0,
      lastrequest: 0,
      chat: [],
    }
    this.onChangeNick 	= this.onChangeNick.bind(this);
    this.onChangeSearch 	= this.onChangeSearch.bind(this);
    this.onChangeIAddC 	  = this.onChangeIAddC.bind(this);
    this.onChangeIAddGN 	= this.onChangeIAddGN.bind(this);
    this.onChangeIAddGI 	= this.onChangeIAddGI.bind(this);
    this.onChangeCCraft 	= this.onChangeCCraft.bind(this);
    this.getCraft 		    = this.getCraft.bind(this);
    this.KeyPressHandler  = this.KeyPressHandler.bind(this);
  }

  //* Вызывается после удаления компонента из DOM
  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, false);
  }

  //* Клик по области
  handleClickOutside = (e) => {
    const block = document.getElementsByClassName('gcprofile')[0];
    const block2 = document.getElementsByClassName('gchelp')[0];
    console.log(e);
    if ('path' in e) {
      if (!e.path.includes(block2) && window.innerWidth < 722) {
        const btn = document.querySelector('.openmenu');
        if (!e.path.includes(btn)) {
          this.setState( {gchelp:false} );
        };
      }
      if (!e.path.includes(block)) {
        const btn = document.querySelector('.btn-gc');
        const btn2 = document.querySelector('.btn-gc-name');
        if (!e.path.includes(btn) && !e.path.includes(btn2)) {
          this.setState( {gcprofile:false} );
        };
      } 
    }
  }

  //* Первый запрос
  async firstapi(t) {
    var paramsconnect = {};
    if (t) {
      await this.connect('a',{'auth':this.state.gctoken});
      await this.connect('t',{'uid':this.state.uid,'username':this.state.gcname});
    } else {
      if (localStorage.getItem('id') != null && localStorage.getItem('username') != null && localStorage.getItem('access_token') != null && localStorage.getItem('uid') != null ) {
        this.setState( {gcid:localStorage.getItem('id'),gcname:localStorage.getItem('username'),gctoken:localStorage.getItem('access_token')} );
        paramsconnect = {'uid':localStorage.getItem('uid'),'username':localStorage.getItem('username')};
      }
      await this.connect('t',paramsconnect);
    }
  }

  //* Вызов сразу после рендера
  async componentDidMount() {
    
    if (window.innerWidth >= 722) {this.setState( {gcprofile:false,gchelp:true} );}
    else {this.setState( {gchelp:false} );}
    
    await this.garland();

    let reg = /access_token=(.*)&=?/i;

    //* Передан токен
		if(window.location.hash.search(reg) !== -1){
      let hash = window.location.hash.match(reg);
      let token = hash[1];
      await this.setState( {gctoken:token} );
      await window.history.pushState("", document.title, window.location.pathname);
      await this.firstapi(1);
    } 
    //* Параметра нет
    else {
      await this.firstapi(0);
      let params = (new URL(document.location)).searchParams; 
      if ( params.get("id") && params.get("id") !== "0" ) {
        if ("i"+params.get("id") in this.state.crafts) {
          await this.newtitle(params.get("id"));
          await this.getCraftF(params.get("id"),0);
          //await this.sitemap();
          if (params.get("craft") === "all") {
            await this.calcgcstart(true,'0');
          }
          if (params.get("craft") === "lite") {
            if ( this.state.clistalt.includes(params.get("id")) ) {
              this.calcgcstart(true,params.get("id"))
            }
          }
        }
      }
    }

    //* Изменение ширины страницы
    this.setState( {widthdoc:window.innerWidth} );
    window.addEventListener("resize", () => {
      if (window.innerWidth >= 722) {this.setState( {gcprofile:false,gchelp:true} );}
      else {this.setState( {gchelp:false} );}
      this.setState( {widthdoc:window.innerWidth} );
    }, false);

    //* document Ловим клики в области страницы
    document.addEventListener('click', this.handleClickOutside, false);
  }

  async sitemap() {
    var items = this.state.items;
    var full = [];
    full.push('<?xml version="1.0" encoding="UTF-8"?>');
    full.push('<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.sitemaps.org/schemas/sitemap/0.9 http://www.sitemaps.org/schemas/sitemap/0.9/sitemap.xsd">');
    Object.keys(this.state.crafts).forEach(function(key) {
      if (key !== 'i0') {
        var temp = items[key];
        if (temp !== undefined) {
          full.push("<url><loc>https://helpgc.ru/?id="+key.slice(1)+"</loc><lastmod>2022-01-10T15:15:51+00:00</lastmod></url>");
        }
      }
    }, this.state.crafts);
    full.push('</urlset>');
    console.log(full.join(''));
  }

  async newtitle(id) {
    document.title = this.state.items["i"+id]['n']+" крафт | HelpGC — Твой подручный | GreenCubes";
  }

  //* POST запрос
  postRequest(url, data) {
    return fetch(url, {
      credentials: 'same-origin',
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
    })
    .then(response => response.json())
  }

  async chatsync() {
    await this.postRequest('https://helpgc.ru/api/chat_messages.php',{'ts':this.state.ts,'wait':20})
    .then(async json => {
      var data = json;
      var ts  = ( data.ts ) ? data.ts : 0;
      var chat  = ( data.content ) ? data.content : [];
      await this.setState( { ts:ts, chat:chat } );	//Чат
      if (this.state.mode === '11') {
        this.setState({ lastrequest:Math.floor(Date.now() / 1000) });
        setTimeout(() => this.chatsync());
      }
    }).catch( async err => {
      await this.setState( { error: 6 } );	//Проблемы со связью
    });
  }

  //* API
	async connect (type, params) {
		await fetch( `https://helpgc.ru/api/?type=${type}&${JSON.stringify(params).replace('{', '').replace('}', '').replace(/"/g, '').replace(/:/g, '=').replace(/,/g, '&')}` )
		.then((response => response.json()))
		.then(async json => {
      let data 	= json;
			if ( data.response ) {
				switch ( data.response.code ) {
					case '1':
            let uid     = ( data.response.uid ) ? data.response.uid : '0';
            let crafts 	= ( data.response.crafts ) ? data.response.crafts[0] : [];
            let clist 	= ( data.response.crafts ) ? data.response.crafts[1] : [];
            let craftsalt = ( data.response.craftsalt ) ? data.response.craftsalt[0] : [];
            let clistalt 	= ( data.response.craftsalt ) ? data.response.craftsalt[1] : [];
            let items 	= ( data.response.items ) ? data.response.items[0] : [];
            let ilist 	= ( data.response.items ) ? data.response.items[1] : [];
            var scope   = ( data.response.scope ) ? data.response.scope : 'user';
            var tg   = ( data.response.tg ) ? data.response.tg : '';
            let part    = ( data.response.part ) ? data.response.part : [];
            let chosen  = ( data.response.chosen ) ? data.response.chosen : [];
            let cases  = ( data.response.cases ) ? data.response.cases : [];
            localStorage.setItem('uid',uid);
            await this.setState( { crafts:crafts,clist:clist,items:items,ilist:ilist,uid:uid,scope:scope,tg:tg,part:part,craftsalt:craftsalt,clistalt:clistalt,chosen:chosen,cases:cases } );
            //console.log ( '%c Ответ от сервера:', 'color: crimson;', '' );
            //console.log(data.response);
            break;
          case '2': case '10':
            await this.setState( { error: 4 } );	//Ошибка запроса
            break;
          case '4':
            await this.setState( { reqstatus: true } ); //Статус запроса
            setTimeout(() => {
              this.setState( { reqstatus: false } );
            }, 2000);
            break;
          case '3':
            let uid2     = ( data.response.uid ) ? data.response.uid : '0';
            await this.setState( {uid:uid2} );
            await this.gc('user',{'access_token':this.state.gctoken});
            break;
          case '5':
            await this.setState( { rror: 4 } );	//Проблемы с авторизацией
            break;
          case '6':
            let chosenlist  = ( data.response.chosen ) ? data.response.chosen : [];
            //console.log(chosenlist);
            let chosenac = chosenlist.includes(this.state.getCraft[0]) ? true : false;
            await this.setState( { chosen:chosenlist, chosenac:chosenac } );	//Избранные
            break;
          case '7':
            var users  = ( data.response.users ) ? data.response.users : [];
            var users_log  = ( data.response.users_log ) ? data.response.users_log : [];
            await this.setState( { users:users, users_log:users_log } );	//Игроки
            break;
          case '8':
            users  = ( data.response.users ) ? data.response.users : [];
            users_log  = ( data.response.users_log ) ? data.response.users_log : [];
            await this.setState( { users:users, users_log:users_log } );	//Игроки
            break;
          case '9':
            users  = ( data.response.users ) ? data.response.users : [];
            users_log  = ( data.response.users_log ) ? data.response.users_log : [];
            await this.setState( { users:users, users_log:users_log } );	//Игроки
            break;
          default: 
            await this.setState( { error: 5 } );	//Проблемы со связью
            break;
        }
        await this.setState( { loading:false } );
			}
		}).catch( async err => {
				await this.setState( { error: 6 } );	//Проблемы со связью
		});
  }

  //* API GC
  async gc (m,params) {
    await fetch( `https://api.greencubes.org/${m}?${JSON.stringify(params).replace('{', '').replace('}', '').replace(/"/g, '').replace(/:/g, '=').replace(/,/g, '&')}` )
    .then((response => response.json()))
		.then(async json => {
      let data 	= json;
			if ( data.id ) {
        let regprepref = /.{1}r.{2}(.{6})\[(.*)]/gm;
        let regcname = /r.{2}(.{6})/gm;
        if (data.nick_color !== null) {
          data.nick_color = "#"+regcname.exec(data.nick_color)[1];
        }
        if (data.prefix !== null) {
          let prefix = regprepref.exec(data.prefix);
          if (prefix === null) {
            regprepref = /\[(.*)]/gm;
            prefix = regprepref.exec(data.prefix);
            data.prefix = [[null,prefix[1]]];
          } else {
            data.prefix = [["#"+prefix[1],prefix[2]]];
          }
          if (data.prefix[0][1].includes('&')) {
            data.prefix = [];
            var str = "&rff66c016G&rfff7f7f7C&r99446666";
            var re = /.{1}r.{2}(.{6})([A-Za-z0-9])/g;
            var res;
            while ((res = re.exec(str)) != null) {
              data.prefix.push([res[0],[res[1]]]);
            }
          }
        } else {
          data.prefix = [[null,null]];
        }
        if (data.reg_date !== null) {
          data.reg_date = Date.parse(data.reg_date)/1000;
        } else {
          data.reg_date = Date.parse(new Date())/1000;
        }
        if (data.badges.length % 7 !== 0) {
          let count = 7 - data.badges.length % 7;
          if ((data.badges.length+count)/7 < 3) {
            count = count+7*(3-(data.badges.length+count)/7);
          }
          for (let x = 0; x<count; x++) {
            data.badges.push({
              "badgeId": 0
            });
          }
        }
        await localStorage.setItem('id',data.id);
        await localStorage.setItem('username',data.username);
        await localStorage.setItem('reg_date',data.reg_date);
        await localStorage.setItem('prefix',JSON.stringify(data.prefix));
        await localStorage.setItem('nick_color',data.nick_color);
        await localStorage.setItem('skin_url',data.skin_url);
        await localStorage.setItem('banned',data.banned);
        await localStorage.setItem('lastseen',data.lastseen.main);
        await localStorage.setItem('online',data.status.main);
        await localStorage.setItem('access_token',this.state.gctoken);
        await this.setState( {
          gcid:localStorage.getItem('id'),
          gcname:localStorage.getItem('username'),
          gcrd:localStorage.getItem('reg_date'),
          gcprefix:JSON.parse(localStorage.getItem('prefix')),
          gcnc:localStorage.getItem('nick_color'),
          gcsu:localStorage.getItem('skin_url'),
          gcbanned:localStorage.getItem('banned'),
          lastseen:localStorage.getItem('lastseen'),
          online:localStorage.getItem('online'),
          gctoken:localStorage.getItem('access_token'),
          badges: data.badges
        } );
			} else {
        await console.log('Ошибка авторизации через GC Auth');
      }
		}).catch( async err => {
				await this.setState( { loading: true, error: 6 } );	//Проблемы со связью
		});
  }
  
  decnum (a,b) { let cases=[2,0,1,1,1,2];return b[(a%100>4 && a%100<20)?2:cases[(a%10<5)?a%10:5]]; }

  //* Дата уведомлений
  texttime ( time ,type ) {
    let newtime 	= new Date();
    let oldtime 	= new Date();
    let notiftime 	= new Date( time * 1000 );
    newtime.setMinutes( newtime.getMinutes() );
    oldtime.setMinutes( newtime.getMinutes() - 1440 );
    notiftime.setMinutes( notiftime.getMinutes());
    let newdate 	= Math.floor( newtime.getTime()/1000 );
    let notifdate 	= Math.floor( notiftime.getTime()/1000 );
    let diff 		= newdate-notifdate;
    let monthlist 	= { "00":"янв ", "01":"фев ", "02":"мар ", "03":"апр ", "04":"мая ", "05":"июн ", "06":"июл ", "07":"авг ", "08":"сен ", "09":"окт ", "10":"ноя ", "11":"дек " };
    let monthliststrong 	= { "00":"01", "01":"02", "02":"03", "03":"04", "04":"05", "05":"06", "06":"07", "07":"08", "08":"09", "09":"10", "10":"11", "11":"12" };
    let info 		= '';
    if ( diff < 60 ) 	{ info = Math.floor( diff ) + this.decnum( Math.floor( diff ),[ ' секунду ',' секунды ',' секунд ' ] ) + " назад "; }
    if ( diff > 60 ) 	{ info = Math.floor( diff/60 ) + this.decnum( Math.floor( diff/60 ),[ ' минуту ',' минуты ',' минут '] ) + " назад "; }
    if ( diff > 1800 ) 	{ info = "полчаса назад "; }
    if ( diff > 3600 ) 	{ info = "час назад "; }
    if ( diff > 7200 ) 	{ info = "2 часа назад "; }
    if ( diff > 10800 ) { info = "3 часа назад "; }
    if ( diff > 14400 ) {
      if ( ( '0' + notiftime.getDate() ).slice( -2 ) === ( '0' + newtime.getDate() ).slice( -2 ) ) {
        info = "сегодня в " + ( '0' + notiftime.getHours() ).slice( -2 ) + ':' + ( '0' + notiftime.getMinutes() ).slice( -2 ) + " "; 
      } else {
        info = "вчера в " + ( '0' + notiftime.getHours() ).slice( -2 ) + ':' + ( '0' + notiftime.getMinutes() ).slice( -2 ) + " ";
      }
    }
    if ( diff > 24*3600 ) {
      if ( ('0' + notiftime.getDate()).slice(-2) === ('0' + oldtime.getDate()).slice(-2) ) {
        info = "вчера в " + ('0' + notiftime.getHours()).slice(-2) + ':' + ('0' + notiftime.getMinutes()).slice(-2) + " "; 
      } else {
        info = ('0' + notiftime.getDate()).slice(-2) + ' ' + monthlist[('0' + notiftime.getMonth()).slice(-2)] + ' в ' + ('0' + notiftime.getHours()).slice(-2) + ':' + ('0' + notiftime.getMinutes()).slice(-2) + ' ';
      }
    }
    if ( diff > 2*24*3600 ) { info = ( '0' + notiftime.getDate() ).slice( -2 ) + ' ' + monthlist[ ( '0' + notiftime.getMonth() ).slice( -2 ) ] + notiftime.getFullYear() + ' года в ' + ( '0' + notiftime.getHours() ).slice( -2 ) + ':' + ( '0' + notiftime.getMinutes() ).slice( -2 ) + ' '; }
    let diffrev = notifdate-newdate;
    if ( diff === 0 ) 	{ info = "только что"; }
    if (diffrev > 0) { info = "настройте время."; }
    switch (type) {
      case 'strong':
        info = ( '0' + notiftime.getDate() ).slice( -2 ) + '.' + monthliststrong[ ( '0' + notiftime.getMonth() ).slice( -2 ) ] + '.' + notiftime.getFullYear() + ', ' + ( '0' + notiftime.getHours() ).slice( -2 ) + ':' + ( '0' + notiftime.getMinutes() ).slice( -2 ) + ' ';
        break;
      default: break;
    }
    return( info );
  }

  garland () {
    setInterval(() => { 
      var garland = this.state.garland;
      garland++;
      if (garland === 5) garland = 1;
      this.setState({ garland:garland });
    }, 800);
  }

  //* Нажат Enter
  KeyPressHandler (e) {
    this.calcgcstart(true,'0')
    e.preventDefault();
  }

  //* Изменение текста строки поиска
  onChangeSearch (e) { 
    this.setState({ searchtext:e.target.value.replace(/\s+/g,' ') }); 
  }

  //* Изменение текста строки поиска
  onChangeNick (e) { 
    this.setState({ nick:e.target.value.replace(/\s+/g,' ') }); 
  }

  //* Изменение текста строки добавления крафта [количество]
  onChangeIAddC (e) {
    let m1list = this.state.m1list;
    let s = e.target.value.replace(/\s+/g,' ');
    if (s[0] === '0' && s.length > 1) {
      s = s.slice(1);
    }
    m1list[`s${this.state.m1active}`] = s;
    this.setState( {m1list:m1list} );
  }

  //* Изменение текста строки добавления крафта [название]
  onChangeIAddGN (e) {
    let m1list = this.state.m1list;
    let s = e.target.value.replace(/\s+/g,' ');
    m1list[`n`] = s;
    this.setState( {m1list:m1list} );
  }

  //* Изменение текста строки добавления крафта [ID]
  onChangeIAddGI (e) {
    let m1list = this.state.m1list;
    let s = e.target.value.replace(/\s+/g,' ');
    if (s[0] === '0' && s.length > 1) {
      s = s.slice(1);
    }
    m1list[`i`] = s;
    this.setState( {m1list:m1list} );
  }

  //* Изменение количества предметов для крафта
  onChangeCCraft (e) {
    let countcraft = this.state.countcraft;
    let s = e.target.value.replace(/\s+/g,' ');
    if (s[0] === '0' && s.length > 1) {
      s = s.slice(1);
    }
    countcraft = s;
    this.setState( {countcraft:countcraft} );
  }

  //* Поиск
  get search () {
    if ( this.state.ilist.length > 0 ) {
      let search = this.state.searchtext.toLowerCase();
      return this.state.ilist.filter( ( {n} ) => n.toLowerCase().indexOf( search ) > -1 );
    } else {
      return this.state.ilist;
    }
  }

  //* Получение крафта
  getCraft = ( e ) => {
    let id = e.currentTarget.dataset.id;
    let data = e.currentTarget.dataset.data;
    this.getCraftF(id,data)
  }

  //* Открытие сундука
  openCase = ( e ) => {
    let id = e.currentTarget.dataset.id;
    this.setState( {mode:'8', getCraft:['',false], searchtext:'', historycraft:[], icase:id} );
  }
  
  //* Функция для получения крафта
  async getCraftF(id,data) {
    var fullid = data > 0 ? `${id}.${data}` : `${id}`;
    if (this.state.mode === '6') {
      await this.setState( { mode:'0' } );
    }
    let chosenac = this.state.chosen.includes(fullid) ? true : false;
    await this.setState( { chosenac:chosenac } );	//Избранные
    var crafts = this.state.clist;
    if (this.state.mode === '1') {
      var m1list = this.state.m1list;
      switch (this.state.m1list.t) {
        case 'c':
          if (this.state.m1active === '10') {
            m1list['ri'] = id;
            m1list['rd'] = data;
            m1list['s10'] = '1';
          } else {
            m1list[`i${this.state.m1active}`] = id;
            m1list[`d${this.state.m1active}`] = data;
            m1list[`s${this.state.m1active}`] = '1';
          }
          break;
        case 't':
          if (this.state.m1active === '2') {
            m1list['ri'] = id;
            m1list['rd'] = data;
          } else {
            m1list[`i${this.state.m1active}`] = id;
            m1list[`d${this.state.m1active}`] = data;
          }
          break;
        case 'i':
          m1list['ri'] = id;
          m1list['rd'] = data;
          break;
        case 'g':
            m1list[`i${this.state.m1active}`] = id;
            m1list[`d${this.state.m1active}`] = data;
          break;
        default:

          break;
      }
      this.setState( {m1list:m1list} );
    } else {
      var history = this.state.historycraft;
      if (id > 0) {
        if ( crafts.includes(fullid) ) {
          var craft = [fullid,true];
          if (history[history.length - 1] !== fullid) {
            await history.push(fullid);
            if (history.length > 5) {
              history = history.slice(-5);
            }
          }
        } else {
          craft = [fullid,false];
        }
      } else {
        craft = [history[history.length - 1],true];
      }
      
      await this.setState( { getCraft:craft, historycraft:history, craftlist:[], craftrest:[], countcraft:1, searchtext:'' } );
    }
  }

  //* Перемещение по истории крафтов
  navCraft = (e) => {
    let id = e.currentTarget.dataset.id;
    let i = e.currentTarget.dataset.i;
    this.navCraftF(id,i);
  }

  //* Функция для перемещения по истории
  async navCraftF(id,i) {
    let history = this.state.historycraft;
    var newh = history.slice(0,i);
    if (newh.length > 5) {
      newh = newh.slice(-4);
    }
    await this.setState( {historycraft:newh} );
    await this.getCraftF(id);
  }

  //* Очистка
  delCraft = () => {
    document.title = "HelpGC — Твой подручный | GreenCubes";
    if (this.state.mode === '1') {
      this.setState( {craftlist:[], craftrest:[], countcraft:1, getCraft:['',false], historycraft:[], searchtext:'', m1active:'', m1list:{"t":"c", "f":"f", "ri":"0", "rd":0, "i1":"0", "i2":"0", "i3":"0", "i4":"0", "i5":"0", "i6":"0", "i7":"0", "i8":"0", "i9":"0", "d1":0, "d2":0, "d3":0, "d4":0, "d5":0, "d6":0, "d7":0, "d8":0, "d9":0, "s1":0, "s2":0, "s3":0, "s4":0, "s5":0, "s6":0, "s7":0, "s8":0, "s9":0, "s10":0}} );
    } else {
      this.setState( {craftlist:[], craftrest:[], countcraft:1, getCraft:['',false], historycraft:[], searchtext:''} );
    }
  }

  //* Проверка на существование ID
  getNameId = (i) => {
    let items = this.state.items;
    i = `i${i}`;
    if ( i in items ) {
      return `${items[i].n} [ID:${items[i].i}${items[i].d > 0 ? `.${items[i].d}`:``}]`;
    } else {
      return `Предмет с ID:${i} не был найден в списке`;
    }
  }

  //! Сделать проверку на существование ID!!!!!!!!!!!!
  //* Вывод информации
  item (i,d,p) {
    let id = d > 0 ? `${i}.${d}` : `${i}`;
    let item = this.state.items[`i${id}`];
    let end = 0;
    if (item) {
      end = item[p];
    } else {
      end = 0;
    }
    return end;
  }

  //* Открытие ссылки авторизации
  async openauth () {
    document.title = "HelpGC — Твой подручный | GreenCubes";
    if (this.state.gcid) {
      await this.setState( {gcprofile:!this.state.gcprofile} );
    } else {
      document.location.href = "https://api.greencubes.org/oauth/authorize?client_id=5&response_type=code&redirect_uri=https://helpgc.ru/auth";
    }
  }

  //* Выход
  async delauth () {
    document.title = "HelpGC — Твой подручный | GreenCubes";
    await localStorage.clear();
    await localStorage.setItem('uid',this.state.uid);
    await this.setState( {gcid:'',gcname:'',gctoken:'',gcprofile:false,scope:'user'} );
    if (window.innerWidth >= 722) {this.setState( {gchelp:true} );}
    else {this.setState( {gchelp:false} );}
  }

  //* Открытие меню
  async infocraft () {
    if (window.innerWidth < 722) {
      await this.setState( {gchelp:!this.state.gchelp} );
    }
  }

 //* Возврат в обычный режим
 async opencraft () {
  document.title = "HelpGC — Твой подручный | GreenCubes";
  await this.setState( {craftlist:[], craftrest:[], countcraft:1, mode:'0', getCraft:['',false], searchtext:'', historycraft:[]} );
}

  //* Режим добавления рецепта
  async addcraft () {
    document.title = "HelpGC — Твой подручный | GreenCubes";
    if (this.state.mode !== '1') {
      await this.setState( {mode:'1', getCraft:['',false], searchtext:'', historycraft:[]} );
    } else {
      await this.setState( {mode:'0', getCraft:['',false], searchtext:'', historycraft:[]} );
    }
  }

  //* Режим редактирования рецепта
  async redcraft () {
    document.title = "HelpGC — Твой подручный | GreenCubes";
    if (this.state.mode !== '2') {
      await this.setState( {mode:'2', getCraft:['',false], searchtext:'', historycraft:[]} );
    } else {
      await this.setState( {mode:'0', getCraft:['',false], searchtext:'', historycraft:[]} );
    }
  }

  //* Режим удаления рецепта
  async deletecraft () {
    document.title = "HelpGC — Твой подручный | GreenCubes";
    if (this.state.mode !== '3') {
      await this.setState( {mode:'3', getCraft:['',false], searchtext:'', historycraft:[]} );
    } else {
      await this.setState( {mode:'0', getCraft:['',false], searchtext:'', historycraft:[]} );
    }
  }

   //* Режим открытия профиля
   async profile () {
    document.title = "HelpGC — Твой подручный | GreenCubes";
    if (this.state.mode !== '4') {
      await this.gc('user',{'access_token':this.state.gctoken});
      await this.setState( {mode:'4', getCraft:['',false], searchtext:'', historycraft:[]} );
    } else {
      await this.setState( {mode:'0', getCraft:['',false], searchtext:'', historycraft:[]} );
    }
  }

  //* Режим открытия избранного
  async chosenc () {
    document.title = "HelpGC — Твой подручный | GreenCubes";
    if (this.state.mode !== '6') {
      await this.gc('user',{'access_token':this.state.gctoken});
      await this.setState( {mode:'6', getCraft:['',false], searchtext:'', historycraft:[]} );
    } else {
      await this.setState( {mode:'0', getCraft:['',false], searchtext:'', historycraft:[]} );
    }
  }

  //* Режим открытия игроков
  async users () {
    document.title = "HelpGC — Твой подручный | GreenCubes";
    if (this.state.mode !== '9') {
      let params = {};
      params['uid'] = this.state.uid;
      params['username'] = this.state.gcname;
      await this.connect('users',params);
      await this.setState( {mode:'9', getCraft:['',false], searchtext:'', historycraft:[]} );
    } else {
      await this.setState( {mode:'0', getCraft:['',false], searchtext:'', historycraft:[]} );
    }
  }

  //* Режим открытия игроков
  async chat () {
    document.title = "HelpGC — Твой подручный | GreenCubes";
    if (this.state.mode !== '11') {
      await this.setState( {mode:'11', getCraft:['',false], searchtext:'', historycraft:[]} );
      await this.chatsync();
    } else {
      await this.setState( {mode:'0', getCraft:['',false], searchtext:'', historycraft:[]} );
    }
  }

  //* Режим открытия игроков
  async users_add () {
    document.title = "HelpGC — Твой подручный | GreenCubes";
    let params = {};
    params['uid'] = this.state.uid;
    params['username'] = this.state.gcname;
    params['nick'] = this.state.nick;
    await this.connect('users_add',params);
    await this.setState( {mode:'9', getCraft:['',false], searchtext:'', nick:'',user:0 , historycraft:[]} );
  }

  //* Режим открытия игроков
  async users_del (id) {
    document.title = "HelpGC — Твой подручный | GreenCubes";
    await this.setState( {user:0} );
    let params = {};
    params['uid'] = this.state.uid;
    params['username'] = this.state.gcname;
    params['id'] = id;
    await this.connect('users_del',params);
    await this.setState( {mode:'9', getCraft:['',false], searchtext:'', nick:'',user:0 , historycraft:[]} );
  }

  //* Режим открытия списка сундуков
  async cases () {
    document.title = "HelpGC — Твой подручный | GreenCubes";
    if (this.state.mode !== '7') {
      await this.setState( {mode:'7', getCraft:['',false], searchtext:'', historycraft:[]} );
    } else {
      await this.setState( {mode:'0', getCraft:['',false], searchtext:'', historycraft:[]} );
    }
  }

  //* Режим открытия прайса Build
  async openBuild () {
    document.title = "HelpGC — Твой подручный | GreenCubes";
    if (this.state.mode !== '5') {
      await this.setState( {mode:'5', getCraft:['',false], searchtext:'', historycraft:[]} );
    } else {
      await this.setState( {mode:'0', getCraft:['',false], searchtext:'', historycraft:[]} );
    }
  }

  //* Вызов функции калькулятора
  async calcgcstart (status,alt) {
    if (!this.state.listload) {
      await this.setState( {listload:true} );
      if(status) {
        if (this.state.getCraft[1]) {
          setTimeout(() => {
          this.setState( { craftlist:[], craftrest:[] } );
          this.calcgc(this.state.getCraft[0],this.state.countcraft,alt); 
          }, 1000);
          
        }
      }
    }
  }

  //* Проверка на лишнее (верстак)
  async calcexcess (id,count,item2,crafts,craftrest,alt) {
    //* Предмет ранее уже был записан в список лишнего
    if (item2 >= 0) {
      //* Баланс позволяет вычесть нам всё нужное количество с остатком
      if (craftrest[item2]['c'] > count) {
        //* Уменьшаем количество
        craftrest[item2]['c'] -= count;
        //* Переменная для подсчёта количества для добавления в список резерва
        let tempcount2 = count;
        count = 0;
        //! Флудилка в консоли. Позже убрать, либо закомментировать.
        console.log ( `%c    <<< Вычитаем из резерва: [${id}]`, `color: #f0899d`, ` — ${this.state.items[`i${id}`].n} ${tempcount2} ${this.decnum(tempcount2, [ 'единицу','единицы','единиц' ])}.` );
      }
      //* Баланс позволяет вычесть нам всё нужное количество без остатка
      else if (craftrest[item2]['c'] === count) {
        //* Переменная для подсчёта количества для добавления в список резерва
        let tempcount2 = count;

        //* Удаляем предмет из списка лишнего
        craftrest.splice(item2, 1);
        count = 0;

        //! Флудилка в консоли. Позже убрать, либо закомментировать.
        console.log ( `%c    ^^^ Удаляем: [${id}]`, `color: #ffffff`, ` — ${this.state.items[`i${id}`].n} ${tempcount2} ${this.decnum(tempcount2, [ 'единицу','единицы','единиц' ])}.` );
      }
      //* Баланс меньше нужного
      else {
        //* Баланс позволяет вычесть часть нужного количества
        if (craftrest[item2]['c'] >= 0) {
          //* Вычитаем из нужного количества резерв
          count -= craftrest[item2]['c'];
          let tempcount3 = craftrest[item2]['c'];
          //* Полностью удаляем предмет из списка лишнего
          craftrest.splice(item2, 1);
          //! Флудилка в консоли. Позже убрать, либо закомментировать.
          console.log ( `%c    <<< Вычитаем из резерва (+ удаляем): [${id}]`, `color: #f0899d`, ` — ${this.state.items[`i${id}`].n} ${tempcount3} ${this.decnum(tempcount3, [ 'единицу','единицы','единиц' ])}.` );
          await this.calcgc (id,count,alt);
          return 0;
        }
        //* Баланс не позволяет вычесть даже 1 единицу
        else {
          //* Переменная для подсчёта количества для добавления в список резерва
          if (crafts[`i${id}`][0].rc > count) {
            var tempcount = crafts[`i${id}`][0].rc - count;
          } else {
            tempcount = (Math.ceil(count/crafts[`i${id}`][0].rc)*crafts[`i${id}`][0].rc)%count;
          }

          //! Флудилка в консоли. Позже убрать, либо закомментировать.
          console.log ( `%c    >>> Пополняем резерв: [${id}]`, `color: #f0899d`, ` — ${this.state.items[`i${id}`].n} ${tempcount} ${this.decnum(tempcount, [ 'единицу','единицы','единиц' ])}.` );
        }
      }
    } 
    //* Предмет ещё не был записан в список лишнего
    else {
      //* Переменная для подсчёта количества для добавления в список резерва
      if (crafts[`i${id}`][0].rc > count) {
        tempcount = crafts[`i${id}`][0].rc - count;
      } else {
        tempcount = (Math.ceil(count/crafts[`i${id}`][0].rc)*crafts[`i${id}`][0].rc)%count;
      }

      if (tempcount > 0) {
        //* Добавляем новый предмет в список лишнего 
        await craftrest.push({'id':id,'n':this.state.items[`i${id}`].n,'c':tempcount,'t':'Неизвестно'});
        
        //! Флудилка в консоли. Позже убрать, либо закомментировать.
        console.log ( `%c    >>> Добавляем в резерв: [${id}]`, `color: #f0899d`, ` — ${this.state.items[`i${id}`].n} ${tempcount} ${this.decnum(tempcount, [ 'единицу','единицы','единиц' ])}.` );
      }

    }
    await this.setState( {craftrest:craftrest} );
    return count;
  }

  //* Калькулятор
  async calcgc (id,count,alt) {
    count = Number(count);
    if (count < 1) {
      count = 1;
    }
    var crafts = this.state.crafts;                     //* Список крафтов
    var craftlist = this.state.craftlist;               //* Список нужных предметов для крафта
    var craftrest = this.state.craftrest;               //* Список оставшихся после крафта предметов
    var item = craftlist.findIndex( a => a.id === id ); //* Индекс предмета в списке нужных айтемов для крафта
    var item2 = craftrest.findIndex( a => a.id === id ); //* Индекс предмета в списке лишних айтемов

    let altcraft = [];

    if (alt !== '0' && this.state.clistalt.includes(alt)) {
      altcraft = this.state.craftsalt[`i${alt}`];
    } else {
      alt = '0';
    }

    //* Если крафт не альтернативный, либо альтернативный и крафт найден
    if (alt === '0' || (alt !== '0' && altcraft.includes(id)) || (alt !== '0' && alt === id)) {
      //* Крафт найден в перечне крафтов
      if (this.state.clist.includes(id)) {

        //! Флудилка в консоли. Позже убрать, либо закомментировать.
        console.log ( `%c@@@ Найден рецепт: [${id}]`, `color: #00887d`, ` — ${this.state.items[`i${id}`].n}.` );
        
        //* Если рецепт заблокирован
        if (crafts[`i${id}`][0].b) {
          //! Флудилка в консоли. Позже убрать, либо закомментировать.
          console.log ( `%cXXX Рецепт заблокирован: [${id}]`, `color: #cccc00`, ` — ${this.state.items[`i${id}`].n}` );
          
          //* Предмет ранее уже был записан в список нужного
          if (item >= 0) {
            craftlist[item]['c'] += count;
          } 
          //* Предмет ещё не был записан в список нужного
          else {
            await craftlist.push({'id':id,'n':this.state.items[`i${id}`].n,'c':count,'t':'Неизвестно'});
          }

          //* Сохраняем
          await this.setState( {craftlist:craftlist, craftrest:craftrest} );
          return true;
        }

        //* Рецепт в верстаке
        if (crafts[`i${id}`][0].t === 'c') {
    
          //* На выходе получаем больше, чем нужно
          /*
          if (count > crafts[`i${id}`][0].rc) {
            if (crafts[`i${id}`][0].rc > 1 && crafts[`i${id}`][0].rc % 2 === 0 && count > 1 && count % 2 === 0) {
              count /= crafts[`i${id}`][0].rc;
            } else if (crafts[`i${id}`][0].rc > 1 && crafts[`i${id}`][0].rc % 3 === 0 && count > 1 && count % 2 === 0) {
              count /= crafts[`i${id}`][0].rc;
            } else {
              //* Ну вроде так оставляем
            }
          }
          */
          if (crafts[`i${id}`][0].rc > count) {
            //* Проверка на лишние предметы
            let temptempcount = await this.calcexcess(id,count,item2,crafts,craftrest,alt);
            if (temptempcount > 0) {
              console.log( `Была проверка на лишние предметы у ${id}, нужно сделать ещё ${temptempcount} ед.` );
            } else {
              console.log( `Была проверка на лишние предметы у ${id}, хватило прошлых запасов.` );
            }
            craftlist = this.state.craftlist;               //* Список нужных предметов для крафта
            craftrest = this.state.craftrest;               //* Список оставшихся после крафта предметов
            count = (temptempcount ? 1:0);
          }
          //* На выходе получаем ровное количество как и в результате крафта
          else if (crafts[`i${id}`][0].rc === count) {
            count = 1;
            //! Флудилка в консоли. Позже убрать, либо закомментировать.
            console.log ( `%c    === Резерв не трогаем. Он не понадобился: [${id}]`, `color: #00994d`, ` — ${this.state.items[`i${id}`].n}.` );
          }
          //* На выходе получаем меньше, чем нужно
          else {
            var temptempcount = await this.calcexcess(id,count,item2,crafts,craftrest,alt);
            if (temptempcount > 0) {
              console.log( `Была проверка на лишние предметы у ${id}, нужно сделать ещё ${temptempcount} ед.` );
            } else {
              console.log( `Была проверка на лишние предметы у ${id}, хватило прошлых запасов.` );
            }
            craftlist = this.state.craftlist;               //* Список нужных предметов для крафта
            craftrest = this.state.craftrest;               //* Список оставшихся после крафта предметов
            count = Math.ceil(temptempcount/crafts[`i${id}`][0].rc);
          }

          if (count > 0) {
            //! Флудилка в консоли. Позже убрать, либо закомментировать.
            console.log ( `%c    *** [${id}] На выходе получаем: ${crafts[`i${id}`][0].rc} ${this.decnum(crafts[`i${id}`][0].rc, [ 'единицу','единицы','единиц' ])}.`, `color: #00887d`, `Умножаем нужное количество предметов на ${count}.` );
            
            //* В цикле просматриваем список нужного для рецепта
            for (var x = 1; x<=9; x++) {
              //* Предмет, отличный от ID: 0
              if (crafts[`i${id}`][0][`i${x}`] !== '0') {
                //* Получаем рецепт
                let fullid = crafts[`i${id}`][0][`d${x}`] > 0 ? `${crafts[`i${id}`][0][`i${x}`]}.${crafts[`i${id}`][0][`d${x}`]}`:crafts[`i${id}`][0][`i${x}`];
                await this.calcgc (fullid,Number(crafts[`i${id}`][0][`s${x}`])*count,alt);
              }
            }
          }
        }

        //* Рецепт в печи
        if (crafts[`i${id}`][0].t === 't') {
          
          //! Флудилка в консоли. Позже убрать, либо закомментировать.
          console.log ( `%c    *** [${id}] На выходе получаем: 1 единицу.`, `color: #a366ff`, `Умножаем нужное количество предметов на ${count}.` );
          //let inpid = crafts[`i${id}`][0].d1 > 0 ? `${crafts[`i${id}`][0][`i1`]}.${crafts[`i${id}`][0][`d1`]}`:`${crafts[`i${id}`][0][`i1`]}`;
          //item = craftlist.findIndex( a => a.id === inpid );
          //* Предмет ранее уже был записан в список нужного
          if (item >= 0) {
            //* Увеличиваем количества предмета в списке нужного
            craftlist[item]['c'] += count;
            
            //! Флудилка в консоли. Позже убрать, либо закомментировать.
            console.log ( `%c    +++ Печь: [${id}]`, `color: #dc143c`, ` — ${this.state.items[`i${id}`].n} ${count} ${this.decnum(count, [ 'единица','единицы','единиц' ])}. Увеличиваем в списоке нужного.` );
          } 
          //* Предмет ещё не был записан в список нужного
          else {
            //* Добавляем новый предмет в список нужного
            await craftlist.push({'id':id,'n':this.state.items[`i${id}`].n,'c':count,'t':'Печь'});

            //! Флудилка в консоли. Позже убрать, либо закомментировать.
            console.log ( `%c    +++ Печь: [${id}]`, `color: #dc143c`, ` — ${this.state.items[`i${id}`].n} ${count} ${this.decnum(count, [ 'единица','единицы','единиц' ])}. Заносим в список нужного.` );
          }
        }
      }
      //* Крафт не найден
      else {
        if (count > 0) {
          //* Предмет ранее уже был записан в список нужного
          if (item >= 0) {
            craftlist[item]['c'] += count;
          } 
          //* Предмет ещё не был записан в список нужного
          else {
            await craftlist.push({'id':id,'n':this.state.items[`i${id}`].n,'c':count,'t':'Неизвестно'});
          }

          //! Флудилка в консоли. Позже убрать, либо закомментировать.
          console.log ( `%c    +++ Неизвестно: [${id}]`, `color: #ff6700`, ` — ${this.state.items[`i${id}`].n} ${count} ${this.decnum(count, [ 'единица','единицы','единиц' ])}. Заносим в список нужного.` );
        } else {
          console.log( `Попытка пропихнуть лишний [${id}] — ${this.state.items[`i${id}`].n} ${count}` );
        }
      }
    } //* Крафт не найден в альтернативном рецепте
    else {
      if (count > 0) {
        //* Предмет ранее уже был записан в список нужного
        if (item >= 0) {
          craftlist[item]['c'] += count;
        } 
        //* Предмет ещё не был записан в список нужного
        else {
          await craftlist.push({'id':id,'n':this.state.items[`i${id}`].n,'c':count,'t':'Неизвестно'});
        }

        //! Флудилка в консоли. Позже убрать, либо закомментировать.
        console.log ( `%c    +++ Неизвестно: [${id}]`, `color: #ff6700`, ` — ${this.state.items[`i${id}`].n} ${count} ${this.decnum(count, [ 'единица','единицы','единиц' ])}. Заносим в список нужного.` );
      } else {
        console.log( `Попытка пропихнуть лишний [${id}] — ${this.state.items[`i${id}`].n} ${count}` );
      }
    }

    //* Сохраняем
    await this.setState( {craftlist:craftlist, craftrest:craftrest} );
  }


  //* Смена интерфейса в режиме создания рецепта
  async mode1change (m) {
    switch (m){
      case '1': 
        await this.setState( {m1list:{"t":"c", "f":"f", "ri":"0", "rd":0, "i1":"0", "i2":"0", "i3":"0", "i4":"0", "i5":"0", "i6":"0", "i7":"0", "i8":"0", "i9":"0", "d1":0, "d2":0, "d3":0, "d4":0, "d5":0, "d6":0, "d7":0, "d8":0, "d9":0, "s1":0, "s2":0, "s3":0, "s4":0, "s5":0, "s6":0, "s7":0, "s8":0, "s9":0, "s10":0}, m1active:''} );
        break;
      case '2':
        if (this.state.m1list.t === 't') {
          await this.mode1change('1');
        } else {
          await this.setState( {m1list:{"t":"t", "ri":"0", "rd":0, "i1":"0", "d1":0}, m1active:''} ); 
        }
        break;
      case '3':
        /*
        if (this.state.m1list.t === 'i') {
          this.mode1change('1');
        } else {
          await this.setState( {m1list:{"ri":"0", "rd":0, "t":"i"}, m1active:'1'} );
        }
        */
        await this.mode1change('1');
        break;
      case '4':
        
        if (this.state.m1list.t === 'g') {
          await this.mode1change('1');
        } else {
          await this.setState( {m1list:{"t":"g", "n":"", "i":"0", "rd":0, "i1":"0", "i2":"0", "i3":"0", "i4":"0", "i5":"0", "i6":"0", "i7":"0", "i8":"0", "i9":"0", "i10":"0", "i11":"0", "i12":"0", "i13":"0", "i14":"0", "i15":"0", "i16":"0", "i17":"0", "i18":"0", "i19":"0", "i20":"0", "i21":"0", "d1":0, "d2":0, "d3":0, "d4":0, "d5":0, "d6":0, "d7":0, "d8":0, "d9":0,"d10":0, "d11":0, "d12":0, "d13":0, "d14":0, "d15":0, "d16":0, "d17":0, "d18":0, "d19":0, "d20":0, "d21":0}, m1active:'0'} );
        }
        
        //await this.mode1change('1');
        break;
      default:
        await this.setState( {m1list:{"t":"c", "f":"f", "ri":"0", "rd":0, "i1":"0", "i2":"0", "i3":"0", "i4":"0", "i5":"0", "i6":"0", "i7":"0", "i8":"0", "i9":"0", "d1":0, "d2":0, "d3":0, "d4":0, "d5":0, "d6":0, "d7":0, "d8":0, "d9":0, "s1":0, "s2":0, "s3":0, "s4":0, "s5":0, "s6":0, "s7":0, "s8":0, "s9":0, "s10":0}, m1active:''} );
        break;
    }
  }

  //* Смена формы в режиме создания рецепта
  async mode1form () {
    let m1list = this.state.m1list;
    if (m1list.f === 't') {
      m1list['f'] = 'f';
    } else {
      m1list['f'] = 't';
    }
    this.setState( {m1list:m1list} );
  }


  //* Выбор нужной ячейки для смены ID
  mode1item = (id) => {
    if (this.state.m1active === id) {
      this.setState( {m1active:'', searchtext: ''} );
    } else {
      this.setState( {m1active:String(id)} );
    }
  }

  //* Сохранение рецепта
  async mode1save () {
    let params = this.state.m1list;
    params['uid'] = this.state.uid;
    params['username'] = this.state.gcname;
    await this.connect('b',params);
  }

  //* Генерация массива Data
  craftlist (id,data) {
    var all = [data];
    if (data === -1) {
      all = [];
      for (var x = 0; x<=this.item(id, 0, 'm') ; x++) {
        all.push(x);
      }
    }
    return all;
  }

  //* Изменение избранного
  async Chosen () {
    let params = this.state.m1list;
    params['uid'] = this.state.uid;
    params['username'] = this.state.gcname;
    params['id'] = this.state.getCraft[0];
    await this.connect('c',params);
  }

  async listload () {
    const el = document.getElementById('craftlist');
    await el.scrollIntoView({'behavior':'smooth'});
    await this.setState( {listload:false} );
  }

  render() {
    var settings = {
      аccessibility: false,
      speed: 0,
      autoplaySpeed: 1000,
      autoplay: true,
      arrows: false,
      draggable: false,
      cssEase: "initial",
      slidesToShow: 1
    };

    const suser = this.state.user;

    function channels(a) {
      switch(a) {
        case 'gl':
          return '';
        case 'great':
          return '';
        case 't':
          return <React.Fragment><span className="GC-yellow GC-prefdown">{`[`}</span><span className="GC-yellow">Торговля</span><span className="GC-wgray GC-yellow">{`] `}</span></React.Fragment>;
        case 'time':
          return <React.Fragment><span className="GC-yellow GC-prefdown">{`[`}</span><span className="GC-yellow">Обновление</span><span className="GC-wgray GC-yellow">{`] `}</span></React.Fragment>;
        default:
          return '';
        }
    }

    return (
      <React.Fragment>
        <div className={`Page ${this.state.mode === '11' ? 'chat-bg':''}`}>
          <div className={`gr gr-${this.state.garland}`}></div>
          {this.state.loading ? (
            <div className="Page-Loader">
              {this.state.error < 1 ? (
                <span style={{marginTop: '30px'}}>Загрузка</span>
              ):(
                <span style={{marginTop: '30px'}}>{this.state.load[this.state.error]}</span>
              ) }
            </div>
          ):(
            <div className="Page-Home">
              <div className='Page-Top'>
                <div className='Page-Block --Top'>
                  <div className="Page-Desc --Top">
                    <span className={`${this.state.gchelp ? 'h-icon openmenu menumini' : 'h-icon openmenu'}`} onClick={ () => this.infocraft() } >HelpGC</span>
                    {this.state.gchelp && 
                      <div className={`${this.state.widthdoc >= 722 ? 'gchelpf' : 'gcmenu gchelp'}`}>
                        <div className={`${this.state.mode === '0' ? 'imgcraft pulse' : 'imgcraft'}`} onClick={ () => this.opencraft() }>{`${this.state.mode === '0' ? 'Рецепты' : 'Рецепты'}`}</div>
                        <div className={`${this.state.mode === '7' ? 'imgcase pulse' : 'imgcase'}`} onClick={ () => this.cases() }>{`${this.state.mode === '7' ? 'Сундуки' : 'Сундуки'}`}</div>
                        <div className={`${this.state.mode === '11' ? 'imgcase pulse' : 'imgcase'}`} onClick={ () => this.chat() }>{`${this.state.mode === '11' ? 'Чат' : 'Чат'}`}</div>
                        {this.state.gcname && <div className={`${this.state.mode === '9' ? 'users pulse' : 'users'}`} onClick={ () => this.users() }>{`${this.state.mode === '9' ? 'Отслеживание' : 'Отслеживание'}`}</div>}
                        {this.state.gcname && <div className={`${this.state.mode === '6' ? 'chosen pulse' : 'chosen'}`} onClick={ () => this.chosenc() }>{`${this.state.mode === '6' ? 'Избранные' : 'Избранные'}`}</div>}
                      </div>
                    }
                    
                    <span className="h-search">
                      {(this.state.mode === '0' || this.state.mode === '1') && 
                        <input disabled={((this.state.m1active === '' && this.state.mode === '1')) && 'disabled'} className="search" style={ this.state.searchtext.length > 0 ? {} : { textAlign:'center'} } type="search" value={ this.state.searchtext } onChange={ this.onChangeSearch } name="searchgc" placeholder={(this.state.mode === '1' ) ? 'Поиск предмета':'Поиск рецепта'} />
                      }
                      <span className="btn btn-gc" style={ {backgroundImage: `url(${this.state.gcid.length > 0 ? GCLogo2 : GCLogo})`} } onClick={() => this.openauth()}>AuthGC</span>
                      {this.state.gcname.length > 0 && 
                        this.state.widthdoc >= 1600 && <span className="btn-gc-name gc-name" onClick={() => this.openauth()}>{this.state.scope !== 'user' && <span className={`pref-${this.state.scope}`}>[{this.state.scope}] </span>}{this.state.gcname}</span>
                      }
                      {this.state.gcprofile && this.state.gcname && 
                        <div className="gcmenu gcprofile">
                          <div className={`${this.state.mode === '4' ? 'gc-name pulse' : 'gc-name'}`} onClick={ () => this.profile() }>{`${this.state.mode === '4' ? '#':''}`}{this.state.scope !== 'user' && <span className={`pref-${this.state.scope}`}>[{this.state.scope}] </span>}{this.state.gcname}</div>
                          {(this.state.scope === 'MOD' || this.state.scope === 'ADMIN' || this.state.scope === 'GC') && <div className={`${this.state.mode === '1' ? 'pulse imgaddcraft' : 'imgaddcraft'}`} onClick={ () => this.addcraft() }>{`${this.state.mode === '1' ? 'Добавить рецепт <' : 'Добавить рецепт'}`}</div>}
                          {(this.state.scope === 'MOD' || this.state.scope === 'ADMIN' || this.state.scope === 'GC') && <div className={`${this.state.mode === '2' ? 'pulse imgredcraft' : 'imgredcraft'}`} onClick={ () => this.redcraft() }>{`${this.state.mode === '2' ? 'Редактировать рецепт <' : 'Редактировать рецепт'}`}</div>}
                          {(this.state.scope === 'MOD' || this.state.scope === 'ADMIN' || this.state.scope === 'GC') && <div className={`${this.state.mode === '3' ? 'pulse imgdelcraft' : 'imgdelcraft'}`} onClick={ () => this.deletecraft() }>{`${this.state.mode === '3' ? 'Удалить рецепт <' : 'Удалить рецепт'}`}</div>}
                          {(this.state.scope === 'GC') && <div>Пункт для группы <span className='pref-GC'>[GC]</span></div>}
                          <div onClick={() => this.delauth()} style={ {color:'#a94442'} }>Выход</div>
                        </div>
                      }
                    </span>
                  </div>
                </div>
              </div>
              {this.state.mode === '0' &&
                <div className='Page-Body'>
                  { ( this.state.historycraft.length > 0 || this.state.getCraft[0].length > 0 ) && 
                    <div className='Page-Block --Shadow'>
                      <div className="Page-Desc --History">
                        <span className="id h-list" onClick={ ( e ) => this.delCraft( e ) }>Очистка</span>
                        {this.state.historycraft.map((id, i) => (
                          <span key={i} className="h-list --history"><span className="id --history" onClick={ ( e ) => {this.newtitle(id);this.navCraft( e )} } data-i={i} data-id={id}>{this.state.items[`i${id}`].n}</span></span>
                        ))}
                      </div>
                    </div>
                  }
                  {(this.state.getCraft[0].length > 0 && this.state.searchtext.length === 0) &&
                    <div className='Page-Block --Shadow'>
                      {(this.state.gcname && this.state.chosenac) && 
                        <div onClick={ () => this.Chosen() } title='Удалить из избранного' className="Chosen add"><img src={Chosen} className="ChosenImg" alt='Удалить из избранного' title='Удалить из избранного' /></div>
                      }
                      {(this.state.gcname && !this.state.chosenac) && 
                        <div onClick={ () => this.Chosen() } title='Добавить в избранные' className="Chosen"><img src={Chosen} className="ChosenImg" alt='Добавить в избранные' title='Добавить в избранные' /></div>
                      }
                      <div className="Page-Desc --Shadow --FC"><a className="itemhref" href={`/?id=${this.state.getCraft[0]}`}>{`${this.getNameId(this.state.getCraft[0])}`}</a></div>
                      { this.state.getCraft[1] ? (
                        <div>
                          {this.state.crafts[`i${this.state.getCraft[0]}`].map((craft, i) => (
                            <div key={i}>
                              {craft['t'] === 't' &&
                                <div className='craft-flex'>
                                  <div className='craft-gui gui'>
                                    <div className='craft-fire'>
                                      <div className="container">
                                        <Slider {...settings}>{this.craftlist(craft.i1,craft.d1).map((data, i) => (<Item dc="1" key={i} s={1} name={this.item(craft.i1, data, 'n')} onClick={ ( e ) => {this.newtitle(craft.i1);this.getCraft( e )} } data-id={craft.i1} data-data={data}>{data > 0 ? `${craft.i1}.${data}`:craft.i1}</Item>))}</Slider>
                                      </div>
                                      <Item dc="1" s={1} name={this.state.items[`i263`].n}>263</Item>
                                      <div className='craft-firegif'></div>
                                      <div className='craft-arrow' title='Рецепт в печи.'></div>
                                      <div className='craft-out'>
                                        <Item dc="1" l='large' s={1} name={this.state.items[`i${this.state.getCraft[0]}`].n}>{this.state.getCraft[0]}</Item>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              }
                              {craft['t'] === 'c' &&
                                <div className='craft-flex'>
                                  <div className='craft-gui gui'>
                                    <div className='craft-table'>
                                      <div className="container"><Slider {...settings}>{this.craftlist(craft.i1,craft.d1).map((data, i) => (<Item dc="1" key={i} s={craft.s1} name={this.item(craft.i1,data,'n')} onClick={ ( e ) => {this.newtitle(craft.i1);this.getCraft( e )} } data-id={craft.i1} data-data={data}>{data > 0 ? `${craft.i1}.${data}`:craft.i1}</Item>))}</Slider></div>
                                      <div className="container"><Slider {...settings}>{this.craftlist(craft.i2,craft.d2).map((data, i) => (<Item dc="1" key={i} s={craft.s2} name={this.item(craft.i2,data,'n')} onClick={ ( e ) => {this.newtitle(craft.i2);this.getCraft( e )} } data-id={craft.i2} data-data={data}>{data > 0 ? `${craft.i2}.${data}`:craft.i2}</Item>))}</Slider></div>
                                      <div className="container"><Slider {...settings}>{this.craftlist(craft.i3,craft.d3).map((data, i) => (<Item dc="1" key={i} s={craft.s3} name={this.item(craft.i3,data,'n')} onClick={ ( e ) => {this.newtitle(craft.i3);this.getCraft( e )} } data-id={craft.i3} data-data={data}>{data > 0 ? `${craft.i3}.${data}`:craft.i3}</Item>))}</Slider></div>
                                      <div className="container"><Slider {...settings}>{this.craftlist(craft.i4,craft.d4).map((data, i) => (<Item dc="1" key={i} s={craft.s4} name={this.item(craft.i4,data,'n')} onClick={ ( e ) => {this.newtitle(craft.i4);this.getCraft( e )} } data-id={craft.i4} data-data={data}>{data > 0 ? `${craft.i4}.${data}`:craft.i4}</Item>))}</Slider></div>
                                      <div className="container"><Slider {...settings}>{this.craftlist(craft.i5,craft.d5).map((data, i) => (<Item dc="1" key={i} s={craft.s5} name={this.item(craft.i5,data,'n')} onClick={ ( e ) => {this.newtitle(craft.i5);this.getCraft( e )} } data-id={craft.i5} data-data={data}>{data > 0 ? `${craft.i5}.${data}`:craft.i5}</Item>))}</Slider></div>
                                      <div className="container"><Slider {...settings}>{this.craftlist(craft.i6,craft.d6).map((data, i) => (<Item dc="1" key={i} s={craft.s6} name={this.item(craft.i6,data,'n')} onClick={ ( e ) => {this.newtitle(craft.i6);this.getCraft( e )} } data-id={craft.i6} data-data={data}>{data > 0 ? `${craft.i6}.${data}`:craft.i6}</Item>))}</Slider></div>
                                      <div className="container"><Slider {...settings}>{this.craftlist(craft.i7,craft.d7).map((data, i) => (<Item dc="1" key={i} s={craft.s7} name={this.item(craft.i7,data,'n')} onClick={ ( e ) => {this.newtitle(craft.i7);this.getCraft( e )} } data-id={craft.i7} data-data={data}>{data > 0 ? `${craft.i7}.${data}`:craft.i7}</Item>))}</Slider></div>
                                      <div className="container"><Slider {...settings}>{this.craftlist(craft.i8,craft.d8).map((data, i) => (<Item dc="1" key={i} s={craft.s8} name={this.item(craft.i8,data,'n')} onClick={ ( e ) => {this.newtitle(craft.i8);this.getCraft( e )} } data-id={craft.i8} data-data={data}>{data > 0 ? `${craft.i8}.${data}`:craft.i8}</Item>))}</Slider></div>
                                      <div className="container"><Slider {...settings}>{this.craftlist(craft.i9,craft.d9).map((data, i) => (<Item dc="1" key={i} s={craft.s9} name={this.item(craft.i9,data,'n')} onClick={ ( e ) => {this.newtitle(craft.i9);this.getCraft( e )} } data-id={craft.i9} data-data={data}>{data > 0 ? `${craft.i9}.${data}`:craft.i9}</Item>))}</Slider></div>
                                    </div>
                                    <div className='craft-arrow' title='Рецепт в верстаке.'></div>
                                    {craft.f === 't' &&
                                      <div className='craft-form' title='Этот рецепт бесформенный, ресурсы могут располагаться в сетке верстака в любом порядке.'><img src={ImForm} alt='Этот рецепт бесформенный, ресурсы могут располагаться в сетке верстака в любом порядке.' /></div>
                                    }
                                    <div className='craft-out'>
                                      <Item dc="1" l='large' s={craft.rc} name={this.state.items[`i${this.state.getCraft[0]}`].n}>{this.state.getCraft[0]}</Item>
                                    </div>
                                  </div>
                                </div>
                              }
                              {craft['t'] === 'c' &&
                                <div>
                                  <div className="Page-Desc --SaveList">
                                    <div className={this.state.listload ? 'disabled':''} onClick={ () => this.calcgcstart(true,'0') } ><img src={List_calc} alt='Рассчитать' title='Рассчитать' /><div>{this.state.listload ? 'Загрузка':'Рассчитать'}</div></div>
                                  </div>
                                  {this.state.clistalt.includes(this.state.getCraft[0]) && 
                                    <div className="Page-Desc --SaveList">
                                      <div className={this.state.listload ? 'disabled':''} onClick={ () => this.calcgcstart(true,this.state.getCraft[0]) } ><img src={List_calc2} alt='Рассчитать' title='Рассчитать' /><div>{this.state.listload ? 'Загрузка':'Рассчитать (упрощённо)'}</div></div>
                                    </div>
                                  }
                                  <div className="craft-input">
                                    <span style={ {fontSize: '15px',lineHeight: '18px'} }>Количество: </span>
                                    <form onSubmit={this.KeyPressHandler} >
                                      <input disabled={this.state.listload && 'disabled'} className="inputtext" style={ String(this.state.countcraft).length > 0 ? {} : { textAlign:'center' } } type="number" onChange={ this.onChangeCCraft } value={ this.state.countcraft } name="searchgc" placeholder='Количество' />
                                    </form>
                                  </div>
                                  <div className="Page-Desc --ListTest">{`Экспериментальная функция. Возможны ошибки при расчёте. Очень сложные рецепты могут рассчитываться дольше, чем более простые. Весь лог для дебага находится в консоли (Ctrl + Shift + I -> Console).`}</div>
                                </div>
                              }
                              {craft['t'] === 't' &&
                                <div>
                                  <div className="Page-Desc --SaveList">
                                    <div className={this.state.listload ? 'disabled':''} onClick={ () => this.calcgcstart(true,'0') } ><img src={List_calc} alt='Рассчитать' title='Рассчитать' /><div>{this.state.listload ? 'Загрузка':'Рассчитать'}</div></div>
                                  </div>
                                  <div className="craft-input">
                                    <span style={ {fontSize: '15px',lineHeight: '18px'} }>Количество: </span>
                                    <form onSubmit={this.KeyPressHandler} >
                                      <input disabled={this.state.listload && 'disabled'} className="inputtext" style={ String(this.state.countcraft).length > 0 ? {} : { textAlign:'center' } } type="number" onChange={ this.onChangeCCraft } value={ this.state.countcraft } name="searchgc" placeholder='Количество' />
                                      </form>
                                  </div>
                                </div>
                              }
                            </div>
                          ))}
                          {this.state.craftlist.length > 0 &&
                            <div id="craftlist" onLoad={ () => this.listload() }>
                              <div className="Page-Desc --ListTest"><img src={Chest_req} alt="Необходимое количество ресурсов" /><span>Необходимое количество ресурсов</span></div>
                              <div className="craft-list">
                                {this.state.craftlist.map((item, i) => (
                                  <div onClick={ ( e ) => this.getCraft( e ) } className={item.t === 'Печь' ? (`Page-Search craft-req --fire`):(`Page-Search craft-req`)} data-id={item.id} key={i}><div title={item.n} className="imgfire"><img src={`https://helpgc.ru/img/${item.id}.png`} alt={item.n} /></div><span title={`${item.c} шт.`}>{item.n} — {Math.trunc(item.c/this.state.items[`i${item.id}`].s) > 0 && `${Math.trunc(item.c/this.state.items[`i${item.id}`].s)}x${this.state.items[`i${item.id}`].s}`}{(Math.trunc(item.c/this.state.items[`i${item.id}`].s) > 0 && item.c%this.state.items[`i${item.id}`].s > 0) ? ` и `:` `}{item.c%this.state.items[`i${item.id}`].s > 0 && `${item.c%this.state.items[`i${item.id}`].s}`} шт.</span></div>
                                ))}
                              </div>
                            </div>
                          }
                          {this.state.craftrest.length > 0 &&
                            <div>
                              <div className="Page-Desc --ListTest"><img src={Chest_rest} alt="Оставшееся количество ресурсов" /><span>Оставшееся количество ресурсов</span></div>
                              <div className="craft-list">
                                {this.state.craftrest.map((item, i) => (
                                  <div onClick={ ( e ) => this.getCraft( e ) } className="Page-Search craft-req" data-id={item.id} key={i}><img src={`https://helpgc.ru/img/${item.id}.png`} alt={item.n} /><span>{item.n} — {Math.trunc(item.c/this.state.items[`i${item.id}`].s) > 0 && `${Math.trunc(item.c/this.state.items[`i${item.id}`].s)}x${this.state.items[`i${item.id}`].s}`}{(Math.trunc(item.c/this.state.items[`i${item.id}`].s) > 0 && item.c%this.state.items[`i${item.id}`].s > 0) ? ` и `:` `}{item.c%this.state.items[`i${item.id}`].s > 0 && `${item.c%this.state.items[`i${item.id}`].s}`} шт.</span></div>
                                ))}
                              </div>
                            </div>
                          }
                        </div>
                        
                      ):(
                        <div>
                          <div className="Page-Desc --Shadow">Крафта данного предмета ещё нет в нашей базе</div>
                            <div className='craft-flex'>
                              <div className='craft-gui gui'>
                                <div className='craft-table --item'>
                                  <Item dc="1" key='1' s="1" name='' >0</Item>
                                  <Item dc="1" key='2' s="1" name='' >0</Item>
                                  <Item dc="1" key='3' s="1" name='' >0</Item>
                                  <Item dc="1" key='4' s="1" name='' >0</Item>
                                  <Item dc="1" key='5' s="1" name='' >0</Item>
                                  <Item dc="1" key='6' s="1" name='' >0</Item>
                                  <Item dc="1" key='7' s="1" name='' >0</Item>
                                  <Item dc="1" key='8' s="1" name='' >0</Item>
                                  <Item dc="1" key='9' s="1" name='' >0</Item>
                                  <Item dc="1" key='10' s="1" name='' >0</Item>
                                  <Item dc="1" key='11' s="1" name={this.state.items[`i${this.state.getCraft[0]}`].n} >{this.state.getCraft[0]}</Item>
                                  <Item dc="1" key='12' s="1" name='' >0</Item>
                                  <Item dc="1" key='13' s="1" name='' >0</Item>
                                  <Item dc="1" key='14' s="1" name='' >0</Item>
                                  <Item dc="1" key='15' s="1" name='' >0</Item>
                                  <Item dc="1" key='16' s="1" name='' >0</Item>
                                  <Item dc="1" key='17' s="1" name='' >0</Item>
                                  <Item dc="1" key='18' s="1" name='' >0</Item>
                                  <Item dc="1" key='19' s="1" name='' >0</Item>
                                  <Item dc="1" key='20' s="1" name='' >0</Item>
                                  <Item dc="1" key='21' s="1" name='' >0</Item>
                                </div>
                              </div>
                            </div>
                          </div>
                      )}
                    </div>
                  }
                  {(this.state.searchtext.length === 0 && this.state.getCraft[0].length === 0 ) &&
                    <div className="Page-Block --Welcome">
                      <div className="Page-Desc --Welcome">Добро пожаловать!</div>
                      <h1 className="Page-Desc --WD">У нас собраны все рецепты и сундуки <span style={ {color: '#27782d'} }>Green</span><span style={ {color: '#333'} }>Cubes</span>. Вам остаётся лишь найти то, что вам нужно.</h1>
                      {1===0 && <div className="Page-Desc --Button"><div onClick={ () => this.openBuild() }>Открыть прайс Build</div></div> }
                    </div>
                  }
                  {(this.state.searchtext.length === 0 && this.state.getCraft[0].length === 0 && 1 === 2 ) &&
                    <div className="Page-Block --Shadow">
                      <div className="Page-Desc --Shadow --job">
                        <h2 className="hh-n">
                          Возможность заработать
                        </h2>
                        <div className="hh-d">
                          У вас есть возможность сделать вклад в наш проект и получить за это <span style={ {fontWeight: '600', color: 'green'} }>Зелень</span>. Работа заключается в проверке рецептов. В данный момент у нас имеется <span style={ {fontWeight: '600'} }>{this.state.clist.length} {this.decnum(this.state.clist.length, [ 'рецепт','рецепта','рецептов' ])}</span>, а это значит что мы могли ошибиться в любом месте. Принимаем технические и косметические ошибки. Технические (неверные данные): ID, MetaData ID, название, количество, ошибка в рецепте, отсутствие какого-то рецепта, совершенно лишний и нерабочий рецепт. Косметические: нет изображения предмета. Отсутствие рецептов с декоративными предметами и модификаторами не считается за ошибку. За каждое найденное несоответствие с действительностью будет вознаграждение в виде <span style={ {fontWeight: '600', color: 'green'} }>100 Зелени</span> + <span style={ {fontWeight: '600', color: 'green'} }>50 Зелени</span> за каждый последующий. Максимальное вознаграждение за данные типы ошибок — <span style={ {fontWeight: '600', color: 'green'} }>500 Зелени</span>. За каждую 5 ошибку дополнительно <span style={ {fontWeight: '600', color: 'green'} }>500 Зелени</span>. Если о данной ошибке уже заявили (от меня доказательства), то вознаграждение о найденной ошибке будет на 50% меньше. Связаться можно в игре <span style={ {fontWeight: '600'} }>/m </span><span style={ {fontWeight: '600',color:'#ff6700'} }>DragonFire</span>, либо в <span style={ {fontWeight: '600',color:'#6d82cb'} }>Discord</span> (<span style={ {fontWeight: '600'} }>CleFer</span>#5305).
                        </div>
                      </div>
                      <div className="Page-Desc --Shadow --job">
                        <div className="hh-n">
                          Срочно и прибыльно
                        </div>
                        <div className="hh-d">
                          Хочешь больше <span style={ {fontWeight: '600', color: 'green'} }>Зелени</span>? Тут тоже придётся проверять, но уже правильно расчёта самого рецепта. За каждое найденное несоответствие с действительностью будет вознаграждение в виде <span style={ {fontWeight: '600', color: 'green'} }>5000 Зелени</span>. За каждую 5 ошибку дополнительно <span style={ {fontWeight: '600', color: 'green'} }>1000 Зелени</span>. Ваше личное количество ошибок не будет увеличиваться, если Вы пришлёте один и тот же баг но с разными ID предмета для крафта. Количество ошибок по этому же багу может увеличиваться только в том случае, если Вы были оповещены о фиксе предыдущего заявления на ошибку. Если о данной ошибке уже заявили (от меня доказательства), то вознаграждение о найденной ошибке будет на 50% меньше. Связаться можно в игре <span style={ {fontWeight: '600'} }>/m </span><span style={ {fontWeight: '600',color:'#ff6700'} }>DragonFire</span>, либо в <span style={ {fontWeight: '600',color:'#6d82cb'} }>Discord</span> (<span style={ {fontWeight: '600'} }>CleFer</span>#5305).
                        </div>
                      </div>
                    </div>
                  }
                  <div className="Page-Block --Shadow">
                    {this.state.searchtext.length > 0 ? (
                      <div>
                        {this.search.length > 0 ? (
                            <div className="craft-list">
                              {this.search.map((item, i) => (
                                <div title={`${item.n} [${item.d > 0 ? `${item.i}.${item.d}`:String(item.i)}]`} className={this.state.getCraft[0] === (item.d > 0 ? `${item.i}.${item.d}`:String(item.i)) ? `Page-Search pulses`:`Page-Search`} onClick={ ( e ) => {this.newtitle(item.d > 0 ? `${item.i}.${item.d}`:String(item.i));this.getCraft( e )} } data-id={item.i} data-data={item.d} key={i}>{item.n}</div>
                                ))}
                            </div>
                          ):(
                            <div className="Page-Desc --Shadow">По запросу {this.state.searchtext}, ничего не было найдено.</div>
                          )}
                      </div>
                    ):(
                      this.state.getCraft[0].length > 0 ? (
                        <div className="Page-Desc --Shadow">Поищем ещё?</div>
                      ):(
                        <div className="Page-Desc helphome" >
                          <div>
                            <h2 className="hh-n">
                              Основная информация
                            </h2>
                            <div className="hh-d">
                              В HelpGC собраны (будут собраны) основные инструменты для взаимодействия с предметами. Под инструментами понимается любое возможное действие, связанное с крафтом тех или иных предметов. В данный момент в базе имеется <span style={ {fontWeight: '600'} }>{this.state.clist.length} {this.decnum(this.state.clist.length, [ 'рецепт','рецепта','рецептов' ])}</span>. По всем вопросам обращаться в игре <span style={ {fontWeight: '600'} }>/m </span><span style={ {fontWeight: '600',color:'#ff6700'} }>DragonFire</span> (или в <span style={ {fontWeight: '600',color:'#6d82cb'} }>Discord</span> (<span style={ {fontWeight: '600'} }>CleFer</span>#5305).
                            </div>
                          </div>
                          <div>
                            <h2 className="hh-n">
                              Как пользоваться?
                            </h2>
                            <div className="hh-d">
                              Для поиска нужного вам крафта предмета необходимо ввести название предмета в строку поиска, расположенную в верхней части сайта. После ввода вам будут предложены варианты ответа на ваш поисковой запрос. Кликнув на необходимый пункт из списка, вам будет представлен рецепт нужного вам предмета. Пример: <span className="id" style={ {fontWeight: '600'} } onClick={ ( e ) => this.getCraft( e ) } data-id="4100.5">Великий значок</span>. При нажатии на кнопку <span style={ {fontWeight: '600'} }>"Рассчитать"</span>, будет происходить расчёт рецепта. Если же рецепта ещё нет, значит его добавят позже.
                            </div>
                          </div>
                          <div>
                            <h2 className="hh-n">
                              Последние нововведения
                            </h2>
                            <div className="hh-d">
                              После того, как игрок узнал как делать Великий значок, он захочет его продать и купить себе что-то интересное. К примеру сундук с рандомными вещами. А почему бы и нет? Теперь не нужно лазать по форуму и статьям, чтобы узнать содержимое сундуков. Всё собрано в одном месте!
                            </div>
                          </div>
                          <div>
                            <div className="hh-n">
                              Канал в Discord
                            </div>
                            <div className="hh-d">
                            <iframe title="Discord GreenCubes" src="https://discord.com/widget?id=522712368862461952&theme=light&" width="100%" height="300px" frameBorder="0" >
                                Ваш браузер не поддерживает плавающие фреймы!
                            </iframe>
                            </div>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                </div>
              }
              {this.state.mode === '1' &&
                <div className='Page-Body'>
                  {(this.state.searchtext.length === 0 && this.state.getCraft[0].length === 0 ) &&
                    <div className="Page-Block --Welcome">
                      <div className="Page-Desc --WD">Вы попали в панель добавления новых рецептов <span style={ {color: '#27782d'} }>Green</span><span style={ {color: '#333'} }>Cubes</span>.</div>
                    </div>
                  }
                  <div className='Page-Block --Shadow'>
                      <div className="Page-Desc --AddCraft">
                        <span className="id" onClick={ ( e ) => this.delCraft( e ) }>Очистка</span>
                      </div>
                      <div className="Page-Desc --AddList">
                        <div onClick={ () => this.mode1change('1') } className={this.state.m1list.t === 'c' ? 'pulseal':''}><img src={List_wb} alt='Верстак' title='Верстак' /><div>Верстак</div></div>
                        <div onClick={ () => this.mode1change('2') } className={this.state.m1list.t === 't' ? 'pulseal':''}><img src={List_stove} alt='Печь' title='Печь' /><div>Печь</div></div>
                        <div onClick={ () => this.mode1change('3') } className={this.state.m1list.t === 'i' ? 'pulseal':'disabled'}><img src={List_item} alt='Предмет' title='Предмет' /><div>Предмет</div></div>
                        <div onClick={ () => this.mode1change('4') } className={this.state.m1list.t === 'g' ? 'pulseal':'disabled'}><img src={List_group} alt='Группа' title='Группа' /><div>Группа</div></div>
                      </div>
                      {(this.state.m1list.t === 't' || this.state.m1list.t === 'c') &&
                        <div className="Page-Desc --Shadow --FC">{this.state.m1list.ri === '0' ? ('Предмет не выбран'):(this.getNameId(this.state.m1list.rd > 0 ? `${this.state.m1list.ri}.${this.state.m1list.rd}`:this.state.m1list.ri))}</div>
                      }
                      <div className="Page-Desc --ListTest">Пользоваться с дикой осторожностью. А лучше и вовсе не трогать, пока не сделано до конца.</div>
                      <div>
                        {this.state.m1list.t === 't' &&
                          <div className='craft-flex'>
                            <div className='craft-gui gui'>
                              <div className='craft-fire'>
                                <Item s="1" dc="1" active={this.state.m1active === '1' ? 'pulseb':''} name={this.item(this.state.m1list.i1, this.state.m1list.d1, 'n')} onClick={ () => this.mode1item( '1' ) }>{this.state.m1list.d1 > 0 ? `${this.state.m1list.i1}.${this.state.m1list.d1}`:this.state.m1list.i1}</Item>
                                <Item s="1" dc="1" name={this.state.items[`i263`].n}>263</Item>
                                <div className='craft-firegif'></div>
                                <div className='craft-arrow' title='Рецепт в печи.'></div>
                                <div className='craft-out'>
                                  <Item dc="1" active={this.state.m1active === '2' ? 'pulseb':''} onClick={ () => this.mode1item( '2' ) } l='large' s={0} name={this.state.items[`i${this.state.m1list.rd > 0 ? `${this.state.m1list.ri}.${this.state.m1list.rd}`:this.state.m1list.ri}`].n}>{this.state.m1list.rd > 0 ? `${this.state.m1list.ri}.${this.state.m1list.rd}`:this.state.m1list.ri}</Item>
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                        {this.state.m1list.t === 'c' &&
                          <div className='craft-flex'>
                            <div className='craft-gui gui'>
                              <div className='craft-table'>
                                <Item dc="1" active={this.state.m1active === '1' ? 'pulseb':''} key='1' s={this.state.m1list.s1} name={this.item(this.state.m1list.i1,this.state.m1list.d1,'n')} onClick={ () => this.mode1item( '1' ) } >{this.state.m1list.d1 > 0 ? `${this.state.m1list.i1}.${this.state.m1list.d1}`:this.state.m1list.i1}</Item>
                                <Item dc="1" active={this.state.m1active === '2' ? 'pulseb':''} key='2' s={this.state.m1list.s2} name={this.item(this.state.m1list.i2,this.state.m1list.d2,'n')} onClick={ () => this.mode1item( '2' ) } >{this.state.m1list.d2 > 0 ? `${this.state.m1list.i2}.${this.state.m1list.d2}`:this.state.m1list.i2}</Item>
                                <Item dc="1" active={this.state.m1active === '3' ? 'pulseb':''} key='3' s={this.state.m1list.s3} name={this.item(this.state.m1list.i3,this.state.m1list.d3,'n')} onClick={ () => this.mode1item( '3' ) } >{this.state.m1list.d3 > 0 ? `${this.state.m1list.i3}.${this.state.m1list.d3}`:this.state.m1list.i3}</Item>
                                <Item dc="1" active={this.state.m1active === '4' ? 'pulseb':''} key='4' s={this.state.m1list.s4} name={this.item(this.state.m1list.i4,this.state.m1list.d4,'n')} onClick={ () => this.mode1item( '4' ) } >{this.state.m1list.d4 > 0 ? `${this.state.m1list.i4}.${this.state.m1list.d4}`:this.state.m1list.i4}</Item>
                                <Item dc="1" active={this.state.m1active === '5' ? 'pulseb':''} key='5' s={this.state.m1list.s5} name={this.item(this.state.m1list.i5,this.state.m1list.d5,'n')} onClick={ () => this.mode1item( '5' ) } >{this.state.m1list.d5 > 0 ? `${this.state.m1list.i5}.${this.state.m1list.d5}`:this.state.m1list.i5}</Item>
                                <Item dc="1" active={this.state.m1active === '6' ? 'pulseb':''} key='6' s={this.state.m1list.s6} name={this.item(this.state.m1list.i6,this.state.m1list.d6,'n')} onClick={ () => this.mode1item( '6' ) } >{this.state.m1list.d6 > 0 ? `${this.state.m1list.i6}.${this.state.m1list.d6}`:this.state.m1list.i6}</Item>
                                <Item dc="1" active={this.state.m1active === '7' ? 'pulseb':''} key='7' s={this.state.m1list.s7} name={this.item(this.state.m1list.i7,this.state.m1list.d7,'n')} onClick={ () => this.mode1item( '7' ) } >{this.state.m1list.d7 > 0 ? `${this.state.m1list.i7}.${this.state.m1list.d7}`:this.state.m1list.i7}</Item>
                                <Item dc="1" active={this.state.m1active === '8' ? 'pulseb':''} key='8' s={this.state.m1list.s8} name={this.item(this.state.m1list.i8,this.state.m1list.d8,'n')} onClick={ () => this.mode1item( '8' ) } >{this.state.m1list.d8 > 0 ? `${this.state.m1list.i8}.${this.state.m1list.d8}`:this.state.m1list.i8}</Item>
                                <Item dc="1" active={this.state.m1active === '9' ? 'pulseb':''} key='9' s={this.state.m1list.s9} name={this.item(this.state.m1list.i9,this.state.m1list.d9,'n')} onClick={ () => this.mode1item( '9' ) } >{this.state.m1list.d9 > 0 ? `${this.state.m1list.i9}.${this.state.m1list.d9}`:this.state.m1list.i9}</Item>
                              </div>
                              <div className='craft-arrow' title='Рецепт в верстаке.'></div>
                              {this.state.m1list.f === 't' ?
                                (
                                  <div onClick={ () => this.mode1form() } className='craft-form' title='Этот рецепт бесформенный, ресурсы могут располагаться в сетке верстака в любом порядке.'><img src={ImForm} alt='Этот рецепт бесформенный, ресурсы могут располагаться в сетке верстака в любом порядке.' /></div>
                                ):(
                                  <div onClick={ () => this.mode1form() } className='craft-form' title='Этот рецепт НЕ бесформенный, ресурсы НЕ могут располагаться в сетке верстака в любом порядке.'><img src={ImForm2} alt='Этот рецепт НЕ бесформенный, ресурсы НЕ могут располагаться в сетке верстака в любом порядке.' /></div>
                                )
                              }
                              <div className='craft-out'>
                                <Item dc="1" active={this.state.m1active === '10' ? 'pulseb':''} l='large' s={this.state.m1list.s10} name={this.state.items[`i${this.state.m1list.rd > 0 ? `${this.state.m1list.ri}.${this.state.m1list.rd}`:this.state.m1list.ri}`].n} onClick={ () => this.mode1item( '10' ) }>{this.state.m1list.rd > 0 ? `${this.state.m1list.ri}.${this.state.m1list.rd}`:this.state.m1list.ri}</Item>
                              </div>
                            </div>
                          </div>
                        }
                        {this.state.m1list.t === 'i' &&
                          <div className='craft-flex'>
                            <div className='craft-gui gui'>
                              <div className='craft-table --item'>
                                <Item dc="1" key='1' s="1" name='' >0</Item>
                                <Item dc="1" key='2' s="1" name='' >0</Item>
                                <Item dc="1" key='3' s="1" name='' >0</Item>
                                <Item dc="1" key='4' s="1" name='' >0</Item>
                                <Item dc="1" key='5' s="1" name='' >0</Item>
                                <Item dc="1" key='6' s="1" name='' >0</Item>
                                <Item dc="1" key='7' s="1" name='' >0</Item>
                                <Item dc="1" key='8' s="1" name='' >0</Item>
                                <Item dc="1" key='9' s="1" name='' >0</Item>
                                <Item dc="1" key='10' s="1" name='' >0</Item>
                                <Item dc="1" active={this.state.m1active === '1' ? 'pulseb':''} key='11' s="1" name={this.state.items[`i${this.state.m1list.rd > 0 ? `${this.state.m1list.ri}.${this.state.m1list.rd}`:this.state.m1list.ri}`].n} onClick={ () => this.mode1item( '1' ) } >{this.state.m1list.rd > 0 ? `${this.state.m1list.ri}.${this.state.m1list.rd}`:this.state.m1list.ri}</Item>
                                <Item dc="1" key='12' s="1" name='' >0</Item>
                                <Item dc="1" key='13' s="1" name='' >0</Item>
                                <Item dc="1" key='14' s="1" name='' >0</Item>
                                <Item dc="1" key='15' s="1" name='' >0</Item>
                                <Item dc="1" key='16' s="1" name='' >0</Item>
                                <Item dc="1" key='17' s="1" name='' >0</Item>
                                <Item dc="1" key='18' s="1" name='' >0</Item>
                                <Item dc="1" key='19' s="1" name='' >0</Item>
                                <Item dc="1" key='20' s="1" name='' >0</Item>
                                <Item dc="1" key='21' s="1" name='' >0</Item>
                              </div>
                            </div>
                          </div>
                        }
                        {this.state.m1list.t === 'g' &&
                          <div className='craft-flex'>
                            <div className='craft-gui gui'>
                              <div className='craft-table --item'>
                                <Item dc="1" active={this.state.m1active === '1' ? 'pulseb':''} key='1' s="1" name={this.item(this.state.m1list.i1,this.state.m1list.d1,'n')} onClick={ () => this.mode1item( '1' ) } >{this.state.m1list.d1 > 0 ? `${this.state.m1list.i1}.${this.state.m1list.d1}`:this.state.m1list.i1}</Item>
                                <Item dc="1" active={this.state.m1active === '2' ? 'pulseb':''} key='2' s="1" name={this.item(this.state.m1list.i2,this.state.m1list.d2,'n')} onClick={ () => this.mode1item( '2' ) } >{this.state.m1list.d1 > 0 ? `${this.state.m1list.i2}.${this.state.m1list.d2}`:this.state.m1list.i2}</Item>
                                <Item dc="1" active={this.state.m1active === '3' ? 'pulseb':''} key='3' s="1" name={this.item(this.state.m1list.i3,this.state.m1list.d3,'n')} onClick={ () => this.mode1item( '3' ) } >{this.state.m1list.d1 > 0 ? `${this.state.m1list.i3}.${this.state.m1list.d3}`:this.state.m1list.i3}</Item>
                                <Item dc="1" active={this.state.m1active === '4' ? 'pulseb':''} key='4' s="1" name={this.item(this.state.m1list.i4,this.state.m1list.d4,'n')} onClick={ () => this.mode1item( '4' ) } >{this.state.m1list.d1 > 0 ? `${this.state.m1list.i4}.${this.state.m1list.d4}`:this.state.m1list.i4}</Item>
                                <Item dc="1" active={this.state.m1active === '5' ? 'pulseb':''} key='5' s="1" name={this.item(this.state.m1list.i5,this.state.m1list.d5,'n')} onClick={ () => this.mode1item( '5' ) } >{this.state.m1list.d1 > 0 ? `${this.state.m1list.i5}.${this.state.m1list.d5}`:this.state.m1list.i5}</Item>
                                <Item dc="1" active={this.state.m1active === '6' ? 'pulseb':''} key='6' s="1" name={this.item(this.state.m1list.i6,this.state.m1list.d6,'n')} onClick={ () => this.mode1item( '6' ) } >{this.state.m1list.d1 > 0 ? `${this.state.m1list.i6}.${this.state.m1list.d6}`:this.state.m1list.i6}</Item>
                                <Item dc="1" active={this.state.m1active === '7' ? 'pulseb':''} key='7' s="1" name={this.item(this.state.m1list.i7,this.state.m1list.d7,'n')} onClick={ () => this.mode1item( '7' ) } >{this.state.m1list.d1 > 0 ? `${this.state.m1list.i7}.${this.state.m1list.d7}`:this.state.m1list.i7}</Item>
                                <Item dc="1" active={this.state.m1active === '8' ? 'pulseb':''} key='8' s="1" name={this.item(this.state.m1list.i8,this.state.m1list.d8,'n')} onClick={ () => this.mode1item( '8' ) } >{this.state.m1list.d1 > 0 ? `${this.state.m1list.i8}.${this.state.m1list.d8}`:this.state.m1list.i8}</Item>
                                <Item dc="1" active={this.state.m1active === '9' ? 'pulseb':''} key='9' s="1" name={this.item(this.state.m1list.i9,this.state.m1list.d9,'n')} onClick={ () => this.mode1item( '9' ) } >{this.state.m1list.d1 > 0 ? `${this.state.m1list.i9}.${this.state.m1list.d9}`:this.state.m1list.i9}</Item>
                                <Item dc="1" active={this.state.m1active === '10' ? 'pulseb':''} key='10' s="1" name={this.item(this.state.m1list.i10,this.state.m1list.d10,'n')} onClick={ () => this.mode1item( '10' ) } >{this.state.m1list.d1 > 0 ? `${this.state.m1list.i10}.${this.state.m1list.d10}`:this.state.m1list.i10}</Item>
                                <Item dc="1" active={this.state.m1active === '11' ? 'pulseb':''} key='11' s="1" name={this.item(this.state.m1list.i11,this.state.m1list.d11,'n')} onClick={ () => this.mode1item( '11' ) } >{this.state.m1list.d1 > 0 ? `${this.state.m1list.i11}.${this.state.m1list.d11}`:this.state.m1list.i11}</Item>
                                <Item dc="1" active={this.state.m1active === '12' ? 'pulseb':''} key='12' s="1" name={this.item(this.state.m1list.i12,this.state.m1list.d12,'n')} onClick={ () => this.mode1item( '12' ) } >{this.state.m1list.d1 > 0 ? `${this.state.m1list.i12}.${this.state.m1list.d12}`:this.state.m1list.i12}</Item>
                                <Item dc="1" active={this.state.m1active === '13' ? 'pulseb':''} key='13' s="1" name={this.item(this.state.m1list.i13,this.state.m1list.d13,'n')} onClick={ () => this.mode1item( '13' ) } >{this.state.m1list.d1 > 0 ? `${this.state.m1list.i13}.${this.state.m1list.d13}`:this.state.m1list.i13}</Item>
                                <Item dc="1" active={this.state.m1active === '14' ? 'pulseb':''} key='14' s="1" name={this.item(this.state.m1list.i14,this.state.m1list.d14,'n')} onClick={ () => this.mode1item( '14' ) } >{this.state.m1list.d1 > 0 ? `${this.state.m1list.i14}.${this.state.m1list.d14}`:this.state.m1list.i14}</Item>
                                <Item dc="1" active={this.state.m1active === '15' ? 'pulseb':''} key='15' s="1" name={this.item(this.state.m1list.i15,this.state.m1list.d15,'n')} onClick={ () => this.mode1item( '15' ) } >{this.state.m1list.d1 > 0 ? `${this.state.m1list.i15}.${this.state.m1list.d15}`:this.state.m1list.i15}</Item>
                                <Item dc="1" active={this.state.m1active === '16' ? 'pulseb':''} key='16' s="1" name={this.item(this.state.m1list.i16,this.state.m1list.d16,'n')} onClick={ () => this.mode1item( '16' ) } >{this.state.m1list.d1 > 0 ? `${this.state.m1list.i16}.${this.state.m1list.d16}`:this.state.m1list.i16}</Item>
                                <Item dc="1" active={this.state.m1active === '17' ? 'pulseb':''} key='17' s="1" name={this.item(this.state.m1list.i17,this.state.m1list.d17,'n')} onClick={ () => this.mode1item( '17' ) } >{this.state.m1list.d1 > 0 ? `${this.state.m1list.i17}.${this.state.m1list.d17}`:this.state.m1list.i17}</Item>
                                <Item dc="1" active={this.state.m1active === '18' ? 'pulseb':''} key='18' s="1" name={this.item(this.state.m1list.i18,this.state.m1list.d18,'n')} onClick={ () => this.mode1item( '18' ) } >{this.state.m1list.d1 > 0 ? `${this.state.m1list.i18}.${this.state.m1list.d18}`:this.state.m1list.i18}</Item>
                                <Item dc="1" active={this.state.m1active === '19' ? 'pulseb':''} key='19' s="1" name={this.item(this.state.m1list.i19,this.state.m1list.d19,'n')} onClick={ () => this.mode1item( '19' ) } >{this.state.m1list.d1 > 0 ? `${this.state.m1list.i19}.${this.state.m1list.d19}`:this.state.m1list.i19}</Item>
                                <Item dc="1" active={this.state.m1active === '20' ? 'pulseb':''} key='20' s="1" name={this.item(this.state.m1list.i20,this.state.m1list.d20,'n')} onClick={ () => this.mode1item( '20' ) } >{this.state.m1list.d1 > 0 ? `${this.state.m1list.i20}.${this.state.m1list.d20}`:this.state.m1list.i20}</Item>
                                <Item dc="1" active={this.state.m1active === '21' ? 'pulseb':''} key='21' s="1" name={this.item(this.state.m1list.i21,this.state.m1list.d21,'n')} onClick={ () => this.mode1item( '21' ) } >{this.state.m1list.d1 > 0 ? `${this.state.m1list.i21}.${this.state.m1list.d21}`:this.state.m1list.i21}</Item>
                              </div>
                            </div>
                          </div>
                        }
                        {(this.state.m1active !== '' && this.state.m1list.t !== 't' && this.state.m1list.t !== 'i' && this.state.m1list.t !== 'g') &&
                          <div className="craft-input">
                            <span style={ {fontSize: '15px',lineHeight: '18px'} }>Количество: </span>
                            <input disabled={(this.state.m1active === '' && this.state.mode === '1' ) && 'disabled'} className="inputtext" style={ this.state.m1list[`s${this.state.m1active}`].length > 0 ? {} : { textAlign:'center'} } type="number" onChange={ this.onChangeIAddC } value={ this.state.m1list[`s${this.state.m1active}`] } name="searchgc" placeholder='Количество' />
                          </div>
                        }
                        {this.state.m1list.t === 'g' &&
                          <div>
                            <div className="craft-input">
                              <span style={ {fontSize: '15px',lineHeight: '18px'} }>Название: </span>
                              <input className="inputtext" style={ this.state.m1list.n.length > 0 ? {} : { textAlign:'center'} } type="search" onChange={ this.onChangeIAddGN } value={ this.state.m1list.n } name="searchgc" placeholder='Название' />
                            </div>
                            <div className="craft-input">
                              <span style={ {fontSize: '15px',lineHeight: '18px'} }>ID группы: </span>
                              <input className="inputtext" style={ this.state.m1list.i.length > 0 ? {} : { textAlign:'center'} } type="number" onChange={ this.onChangeIAddGI } value={ this.state.m1list.i } name="searchgc" placeholder='ID группы' />
                            </div>
                          </div>
                        }
                        <div>
                          <div className="Page-Desc --SaveList">
                            <div className={this.state.reqstatus ? 'success':''} onClick={ () => this.mode1save() } ><img src={List_save} alt='Сохранить' title='Сохранить' /><div>Сохранить</div></div>
                          </div>
                        </div>
                      </div>
                  </div>
                  {this.state.searchtext.length > 0 &&
                    <div className="Page-Block --Shadow">
                      {this.search.length > 0 ? (
                        <div className="craft-list">
                          {this.search.map((item, i) => (
                            <div title={`${item.n} [${item.d > 0 ? `${item.i}.${item.d}`:String(item.i)}]`} className="Page-Search" onClick={ ( e ) => this.getCraft( e ) } data-id={item.i} data-data={item.d} key={i}>{item.n}</div>
                            ))}
                        </div>
                      ):(
                        <div className="Page-Desc --Shadow">По запросу {this.state.searchtext}, ничего не было найдено.</div>
                      )}
                    </div>
                  }
                </div>
              }
              {this.state.mode === '2' &&
                <div className='Page-Body'>
                  {(this.state.searchtext.length === 0 && this.state.getCraft[0].length === 0 ) &&
                    <div className="Page-Block --Welcome">
                      <div className="Page-Desc --WD">Вы попали в панель редактирования рецептов <span style={ {color: '#27782d'} }>Green</span><span style={ {color: '#333'} }>Cubes</span>.</div>
                    </div>
                  }
                  <div className="Page-Block --Block-Shadow">
                    <div className="Page-Desc --ListTest">Полигон для испытаний</div>
                  </div>
                </div>
              }
              {this.state.mode === '3' &&
                <div className='Page-Body'>
                  {(this.state.searchtext.length === 0 && this.state.getCraft[0].length === 0 ) &&
                    <div className="Page-Block --Welcome">
                      <div className="Page-Desc --WD">Вы попали в панель удаления рецептов <span style={ {color: '#27782d'} }>Green</span><span style={ {color: '#333'} }>Cubes</span>.</div>
                    </div>
                  }
                  <div className="Page-Block --Block-Shadow">
                    <div className="Page-Desc --ListTest">Полигон для испытаний</div>
                  </div>
                </div>
              }
              {this.state.mode === '4' &&
                <div className='Page-Body'>
                  {(this.state.searchtext.length === 0 && this.state.getCraft[0].length === 0 ) &&
                    <div className="Page-Block --Welcome">
                      <div className="Page-Desc --WD">Вы попали в свой профиль <span style={ {color: '#27782d'} }>Green</span><span style={ {color: '#333'} }>Cubes</span>.</div>
                    </div>
                  }
                  <div className="Page-Block --Block-Shadow">
                    <div className="Page-Desc helphome --profile" >
                      <div>
                        <div className="hh-n casename">
                          {this.state.gcprefix[0][1] !== null && <span style={{color:this.state.gcnc}}>[{this.state.gcprefix.map((item, i) => (<span key={i} style={{color:item[0]}}>{item[1]}</span>))}]</span>}<span style={{color:this.state.gcnc}}>{this.state.gcname}</span>
                        </div>
                        <div className="hh-d caseimg">
                          <div className="frame_face"><div className="skin-f-8x" style={{backgroundImage:'url('+this.state.gcsu+')'}} /></div>
                        </div>
                      </div>
                      <div>
                        <div className="hh-n">
                          Информация
                        </div>
                        <div className="hh-d">
                          <p><span className="fw" >ID: </span>{this.state.gcid}</p>
                          <p><span className="fw" >Статус: </span>{this.state.online === 'false' ? 'не в сети':'в сети'}</p>
                          <p><span className="fw" >Последний вход: </span>{this.texttime(this.state.lastseen)}</p>
                          <p><span className="fw" >Наличие бана: </span>{this.state.gcbanned === 'false' ? 'нет':'да'}</p>
                          <p><span className="fw" >Дата регистрации: </span>{this.texttime(this.state.gcrd)}</p>
                          <p><span className="fw" >Права на сайте: </span><span className={`pref-${this.state.scope}`}>{this.state.scope}</span></p>
                          <p><span className="fw" >Telegram ключ: </span>{this.state.tg}</p>
                          <p><span className="fw" >Telegram бот: </span><a className="link" href="https://t.me/gcusers_bot" target="_blank" rel="noopener noreferrer" >@gcusers_bot</a></p>
                        </div>
                      </div>
                      <div>
                        <div className="hh-n">
                          Значки
                        </div>
                        <div className="hh-d">
                          <div className='craft-flex'>
                            <div className='craft-gui gui'>
                              {this.state.badges.length > 0 ? (
                                <div className='craft-table --item'>
                                  {this.state.badges.map((item, i) => (
                                    <Item dc="1" key={i} s={item.badgeId !== 0 ? item.count:1} name={item.badgeId !== 0 ? this.state.items[`i${item.badgeId}.${item.badgeData}`].n:''} >{item.badgeId !== 0 ? `${item.badgeId}.${item.badgeData}`:0}</Item>
                                ))}
                                </div>
                              ):
                              (
                                <div className='craft-table --item'>
                                  <Item dc="1" key='1' s="1" name='' >0</Item>
                                  <Item dc="1" key='2' s="1" name='' >0</Item>
                                  <Item dc="1" key='3' s="1" name='' >0</Item>
                                  <Item dc="1" key='4' s="1" name='' >0</Item>
                                  <Item dc="1" key='5' s="1" name='' >0</Item>
                                  <Item dc="1" key='6' s="1" name='' >0</Item>
                                  <Item dc="1" key='7' s="1" name='' >0</Item>
                                  <Item dc="1" key='8' s="1" name='' >0</Item>
                                  <Item dc="1" key='9' s="1" name='' >0</Item>
                                  <Item dc="1" key='10' s="1" name='' >0</Item>
                                  <Item dc="1" key='11' s="1" name='' >0</Item>
                                  <Item dc="1" key='12' s="1" name='' >0</Item>
                                  <Item dc="1" key='13' s="1" name='' >0</Item>
                                  <Item dc="1" key='14' s="1" name='' >0</Item>
                                  <Item dc="1" key='15' s="1" name='' >0</Item>
                                  <Item dc="1" key='16' s="1" name='' >0</Item>
                                  <Item dc="1" key='17' s="1" name='' >0</Item>
                                  <Item dc="1" key='18' s="1" name='' >0</Item>
                                  <Item dc="1" key='19' s="1" name='' >0</Item>
                                  <Item dc="1" key='20' s="1" name='' >0</Item>
                                  <Item dc="1" key='21' s="1" name='' >0</Item>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
              {this.state.mode === '5' &&
                <div className='Page-Body'>
                  {(this.state.searchtext.length === 0 && this.state.getCraft[0].length === 0 ) &&
                    <div className="Page-Block --Welcome">
                      <div className="Page-Desc --WD">Вы попали на страницу магазина Build сервера <span style={ {color: '#27782d'} }>Green</span><span style={ {color: '#333'} }>Cubes</span>.</div>
                      <div className="Page-Desc --Button"><div onClick={ () => this.openBuild() }>Вернуться</div></div>
                    </div>
                  }
                  <div className="Page-Block --Block-Shadow">
                    <div className="Page-Desc --ListTest">Бан</div>
                  </div>
                </div>
              }
              {this.state.mode === '6' &&
                <div className='Page-Body'>
                  {(this.state.searchtext.length === 0 && this.state.getCraft[0].length === 0 ) &&
                    <div className="Page-Block --Welcome">
                      <div className="Page-Desc --WD">Вы попали на страницу с избранными рецептами</div>
                      <div className="Page-Desc --Button"><div onClick={ () => this.chosenc() }>Вернуться</div></div>
                    </div>
                  }
                  <div className="Page-Block --Block-Shadow">
                      <div className="Page-Desc --AddList --Cases">
                        {this.state.chosen.length > 0 ? (this.state.chosen.map((id, i) => (
                          <div key={i} onClick={ (e) => this.getCraft( e ) } data-id={id} ><img src={`https://helpgc.ru/img/${id}.png`} alt={this.state.items[`i${id}`].n} title={this.state.items[`i${id}`].n} /><div>{this.state.items[`i${id}`].n}</div></div>
                        ))):(
                          <div>Пусто</div>
                        )}
                      </div>
                  </div>
                </div>
              }
              {this.state.mode === '7' &&
                <div className='Page-Body'>
                  {(this.state.searchtext.length === 0 && this.state.getCraft[0].length === 0 ) &&
                    <div className="Page-Block --Welcome">
                      <div className="Page-Desc --WD">Вы попали на страницу с сундуками сервера <span style={ {color: '#27782d'} }>Green</span><span style={ {color: '#333'} }>Cubes</span>.</div>
                    </div>
                  }
                  <div className="Page-Block --Block-Shadow">
                      <div className="Page-Desc --AddList --Cases">
                        {this.state.cases.map((item, i) => (
                          <div key={i} onClick={ (e) => this.openCase( e ) } data-id={i} ><img src={`https://helpgc.ru/img/${item.id}.png`} alt={this.state.items[`i${item.id}`].n} title={this.state.items[`i${item.id}`].n} /><div>{this.state.items[`i${item.id}`].n}</div></div>
                        ))}
                      </div>
                  </div>
                </div>
              }
              {(this.state.mode === '8' && this.state.icase !== null) &&
                <div className='Page-Body'>
                  <div className="Page-Block --Welcome">
                    <div className="Page-Desc helphome" >
                      <div>
                        <div className="hh-n casename">
                          {this.state.items[`i${this.state.cases[this.state.icase].id}`].n}
                        </div>
                        <div className="hh-d caseimg">
                          <img src={`https://helpgc.ru/img/case/${this.state.cases[this.state.icase].id}.png`} alt={this.state.items[`i${this.state.cases[this.state.icase].id}`].n} title={this.state.items[`i${this.state.cases[this.state.icase].id}`].n} width="128" />
                        </div>
                      </div>
                      <div>
                        <div className="hh-n">
                          Информация
                        </div>
                        <div className="hh-d">
                          {this.state.cases[this.state.icase].desc}
                        </div>
                      </div>
                      <div>
                        <div className="hh-d">
                          {this.state.cases[this.state.icase].id === '1704' ?
                          (`Он появляется в случайном месте на поверхности в мире через некоторое время после уничтожения редкого предмета. Любой игрок может попробовать найти Мистический сундук, кто найдёт его первым — получает предмет, который ранее кто-то уничтожил. Найденный предмет будет содержать строку в описании, кем он был найден в Мистическом сундуке, редкие предметы будут помнить всех игроков, которые их нашли, если будут уничтожены несколько раз.`):
                          (`Открытие предмета осуществляется правой кнопкой мыши по данному предмету в руке. После чего появляется интерфейс получения рандомных предметов, который содержит в себе список предметов возможные к получению. При нажатии кнопки "Принять" на последней странице списка игрок получает рандомно-выданные предметы из предлагаемых в этом корзинке. ${this.state.items[`i${this.state.cases[this.state.icase].id}`].n} после этого исчезает.`)  
                          }
                        </div>
                      </div>
                    </div>
                    <div className="Page-Desc --Button"><div onClick={ () => this.cases() }>Вернуться</div></div>
                  </div>
                  {this.state.cases[this.state.icase].drop.length > 0 &&
                    <div className="Page-Block --Block-Shadow --Case">
                      <div className="Page-Desc --WD">100% шанс получения одного из предметов</div>
                      <div className="Page-Desc --AddList --Case">
                        {this.state.cases[this.state.icase].drop.map((item, i) => (
                          <div key={i} onClick={ (e) => this.getCraft( e ) } data-id={item[0]} ><Item v={item} dc="2" s={item[1]} name={item[2].length === 0 ? this.state.items[`i${item[0]}`].n : item[2]} key={i} onClick={ (e) => this.getCraft( e ) } data-id={item[0]} >{item[0]}</Item><div>{item[2].length === 0 ? this.state.items[`i${item[0]}`].n : item[2]}</div></div>
                        ))}
                      </div>   
                    </div>
                  }
                  {this.state.cases[this.state.icase].drop2.length > 0 &&
                    <div className="Page-Block --Block-Shadow --Case">
                      <div className="Page-Desc --WD">Какой-то шанс на получение дополнительных предметов</div>
                      <div className="Page-Desc --AddList --Case">
                        {this.state.cases[this.state.icase].drop2.map((item, i) => (
                          <div key={i} onClick={ (e) => this.getCraft( e ) } data-id={item[0]} ><Item v={item} dc="2" s={item[1]} name={item[2].length === 0 ? this.state.items[`i${item[0]}`].n : item[2]} key={i} onClick={ (e) => this.getCraft( e ) } data-id={item[0]} >{item[0]}</Item><div>{item[2].length === 0 ? this.state.items[`i${item[0]}`].n : item[2]}</div></div>
                        ))}
                      </div>   
                    </div>
                  }
                  {this.state.cases[this.state.icase].drop3.length > 0 &&
                    <div className="Page-Block --Block-Shadow --Case">
                      <div className="Page-Desc --WD">Какой-то шанс на получение ещё одних дополнительных предметов</div>
                      <div className="Page-Desc --AddList --Case">
                        {this.state.cases[this.state.icase].drop3.map((item, i) => (
                          <div key={i} onClick={ (e) => this.getCraft( e ) } data-id={item[0]} ><Item v={item} dc="2" s={item[1]} name={item[2].length === 0 ? this.state.items[`i${item[0]}`].n : item[2]} key={i} onClick={ (e) => this.getCraft( e ) } data-id={item[0]} >{item[0]}</Item><div>{item[2].length === 0 ? this.state.items[`i${item[0]}`].n : item[2]}</div></div>
                        ))}
                      </div>   
                    </div>
                  }
                </div>
              }
              {this.state.mode === '9' &&
                <div className='Page-Body'>
                  <div className="Page-Block --Welcome">
                    <div className="Page-Desc --WD">Вы попали на страницу с игроками для отслеживания</div>
                    <div className="Page-Desc --Button"><div onClick={ () => this.users() }>Вернуться</div></div>
                  </div>
                  <div className="user_form">
                    <input className="search user_input" style={ this.state.nick.length > 0 ? {} : { textAlign:'center'} } type="search" value={ this.state.nick } onChange={ this.onChangeNick } name="searchgc" placeholder="Ник" />
                    <div className="user_button"><div onClick={ () => this.users_add() }>Добавить</div></div>
                  </div>
                  {this.state.user > 0 ? (
                    <div className="Page-Block --Block-Shadow">
                      <div className="Page-Desc --WD">История игрока {this.state.users.filter(function(item){return(item['id'] === ""+suser)})[0]['nick']}</div>
                      <div className="frame_face" style={{margin:'auto'}}><div className="skin-f-8x" style={{backgroundImage:'url(http://greenusercontent.net/mc/skins/'+this.state.users.filter(function(item){return(item['id'] === ""+suser)})[0]['nick']+'.png)'}} /></div>
                      <div className="Page-Desc --AddList --Cases">
                        {this.state.users_log.filter(function(item){return(item['id'] === ""+suser)}).length > 0 ? (this.state.users_log.filter(function(item){return(item['id'] === ""+suser)}).map((log, i) => (
                          <div key={i} ><div>{i+1}.</div><div className="user_date">{log.status === '1' ? 'Вход' : log.status === '0' ? 'Выход' : ''} <abbr rel="tooltip" title={+log.date > 0 ? this.texttime(log.date, 'strong') : 'Неизвестно'}>{+log.date > 0 ? this.texttime(log.date) : 'Неизвестно'}</abbr></div><div className={`online online-${log.status}`}>{log.status === '1' ? '' : log.status === '0' ? '' : 'Неизвестно'}</div></div>
                        ))):(
                          <div>Пусто</div>
                        )}
                      </div>
                  </div>
                  ) : (
                    null
                  )}
                  <div className="Page-Block --Block-Shadow">
                    <div className="Page-Desc --WD">Список игроков</div>
                    <div className="Page-Desc --AddList --Cases">
                      {this.state.users.length > 0 ? (this.state.users.map((user, i) => (
                        <div key={i} onClick={ (e) => {
                          e.preventDefault();
                          if(e.target === e.currentTarget) {
                            this.setState({ user:user.id })
                          }
                        } } data-id={user.id} ><div onClick={() => this.setState({ user:user.id })} className="skin-f-4x" style={{backgroundImage:'url(http://greenusercontent.net/mc/skins/'+user.nick+'.png)'}} /><div onClick={() => this.setState({ user:user.id })}>{user.nick}</div><div onClick={() => this.setState({ user:user.id })} className={`online online-${user.status}`}>{user.status === '1' ? '' : ''}</div><div className="user_remove" onClick={ () => this.users_del(user.id) } ><span></span></div></div>
                      ))):(
                        <div>Пусто</div>
                      )}
                    </div>
                  </div>
                </div>
              }
              {this.state.mode === '11' &&
                <div className='Page-Body'>
                  <div className="Page-Block --Welcome">
                    <div className="Page-Desc --WD">Вы попали на страницу чата основного сервера</div>
                    <div className="Page-Desc --Button"><div onClick={ () => this.chat() }>Вернуться</div></div>
                  </div>
                  <div key="time" className={`message time`} >
                    <span className={`GC-text GC-wtext`}>{+this.state.ts > 0 ? 'Последнее изменение '+this.texttime(this.state.ts, 'strong') : 'Нет истории'}</span>
                  </div>
                  <div key="time2" className={`message time`} >
                    <span className={`GC-text GC-wtext`}>{+this.state.lastrequest > 0 ? 'Последнее обновление '+this.texttime(this.state.lastrequest, 'strong') : 'Не обновлено'}</span>
                  </div>
                  <div className="Page-Block --Block-Shadow --Chat">
                    <div className="Page-Desc --Chat">
                      {this.state.chat.length > 0 ? (this.state.chat.map((message, i) => (
                        <React.Fragment>
                          <Tooltip placement="bottomLeft" title={
                            <div style={{display:'flex',flexDirection:'column'}}>
                              <p>{+message.date > 0 ? this.texttime(message.date, 'strong') : 'Неизвестно'}</p>
                            </div>
                          }>
                          <div data-tip data-for={`gc-message-${i}`} key={`${message.date}-${i}`} className={`message ch-${message.channel}`} >
                            {message.me === '1' ? <span className="GC-star">*</span>:``}
                            <span>{channels(message.channel)}</span>
                            {message.channel === 'great' ? <span className="GC-wgreen" >Игрок </span> : ``}
                            <Tooltip placement="topLeft" title={
                              <div style={{display:'flex',flexDirection:'column'}}>
                                {message.nick ? <p><div className="frame_face" style={{margin:'auto'}}><div className="skin-f-8x" style={{backgroundImage:'url(http://greenusercontent.net/mc/skins/'+message.nick+'.png)'}} /></div></p> : ``}
                                <p>{+message.date > 0 ? this.texttime(message.date, 'strong') : 'Неизвестно'}</p>
                              </div>
                            }>
                            {message.prefix ? <React.Fragment><span className="GC-wtext GC-prefdown">{`[`}</span><span className="GC-prefix">{message.prefix}</span><span className="GC-wtext GC-prefdown">{`] `}</span></React.Fragment>:``}
                            {<span><span className="GC-wtext GC-nickdown">{`<`}</span><span className="GC-nick">{message.nick}</span><span className="GC-wtext GC-nickdown">{`> `}</span></span>}
                            </Tooltip>
                            {message.channel === 'great' ? <span className="GC-wgreen">продал </span> : ``}
                            <span className={`GC-text ${message.channel === 'great' ? ' GC-wpurple':''}`}>{message.text}</span>
                            {message.channel === 'great' ? <span className="GC-wgreen"> и получил </span> : ``}
                            {message.channel === 'great' ? <span className="GC-wtext">{message.money}</span> : ``}
                            {message.channel === 'great' ? <span className="GC-wgreen"> зелени! </span> : ``}
                            {
                              // this.texttime(message.date, 'strong')
                            }
                          </div>
                          </Tooltip>
                        </React.Fragment>
                      ))):(
                        <div style={{marginTop:30,textAlign:'center'}}>История чата пуста</div>
                      )}
                    </div>
                  </div>
                </div>
              }
              <div className="Page-Bottom">
                <div className='Page-Block --Bottom'>
                  <div className="Page-Desc --Bottom">
                    <div className="gc-list">
                      {this.state.part.length > 0 &&
                        this.state.part.map((item, i) => (
                        <div key={i} onClick={ () => window.open(item.u, "_blank") }>{item.n}</div>
                        ))
                      }
                    </div>
                  </div>
                  <div className="Page-Desc --Footer">
                    <div onClick={ () => window.open("https://clefer.ru/", "_blank") }>© DragonFire, 2020-2025</div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className={`${this.state.mode === '11' ? 'chat-bg2':''} loadwindowfull ${this.state.listload ? 'show':''}`}>
          <div className="loadwindow">
            <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
          </div>
        </div>
        
      </React.Fragment>
    );
  }
}

export default App;
